/* SPARC Shared V42.5 — replace the previous configurator script; do not load both. */
(function () {
  "use strict";

  if (window.__SPARC_MUSCLE_V10_LOADED__) return;
  window.__SPARC_MUSCLE_V10_LOADED__ = true;

  var IDS = {
    finish: "sparc-muscle-finish",
    grip: "sparc-muscle-grip",
    leatherWrap: "sparc-shared-leather-wrap",
    leatherColor: "sparc-muscle-leather-color",
    leatherTemplate: "sparc-muscle-leather-template",
    stitching: "sparc-shared-stitching",
    hornLogo: "sparc-shared-horn-logo",
    adapter: "sparc-muscle-adapter",
    hubSleeve: "sparc-muscle-hub-sleeve",
    columnSpacer: "sparc-muscle-column-spacer",
    columnSpacerFinish: "sparc-muscle-column-spacer-finish",
    careKit: "sparc-shared-care-kit"
  };

  /* Only selectors that must exist before the configurator can mount.
     Hulk owns all conditional options; those are discovered dynamically. */
  var CORE_REF_KEYS = ["finish"];

  var STITCH_COLORS = {
    "Black":"#151515","Red":"#b62323","White":"#efefef","Silver":"#a4a4a4",
    "Gray":"#6f6f6f","Gold":"#c7a32b","Tan":"#b99a74","Brown":"#765038",
    "Dark Brown":"#402b22","Dark Blue":"#263e6d","Lime Green":"#82c341","Purple":"#673a78"
  };

  var FRIENDLY = {
    "None (raw finish)": "No Leather",
    "Sparc Logo": "SPARC Logo",
    "Sparc Logo Delete": "Logo Delete"
  };

  var refs = {}, panel = null, sourceHost = null;
  var accs = {}, tabs = {}, mirrors = {};
  var syncPending = false, syncTimer = null, spacerFinishWatchTimer = null, resizeTimer = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clean(s) { return String(s || "").replace(/\s+/g," ").trim(); }
  function friendly(v) {
    if (!v) return "Not selected";
    var display = FRIENDLY[v] || v;

    /* Hulk can decorate rendered option values with price notation such as
       [ $75.00 ], | $75.00 |, or (+$75.00). Strip that only from our
       customer-facing display; the real source value remains untouched. */
    display = String(display)
      .replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ")
      .replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ")
      .replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return display;
  }

  function normalizeAccessoryValue(value) {
    return friendly(value)
      .replace(/[\u201C\u201D\u2033]/g, '"')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .toLowerCase()
      .trim();
  }

  function valueEquals(value, expected) {
    var left = normalizeAccessoryValue(value);
    var right = normalizeAccessoryValue(expected);

    return left === right;
  }

  function spacerIsSelected(value) {
    var v = normalizeAccessoryValue(value);

    return (
      v === '1"' ||
      v === '1.5"'
    );
  }


  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  // Shared discovery: IDs identify fields; roles group conditional alternatives.
  // Existing IDs remain supported. New fields can use sparc-role-<role> classes.
  var ROLE_NAMES = {
    finish:"finish", grip:"grip", leatherWrap:"leather-wrap",
    leatherColor:"leather-color", leatherTemplate:"leather-template",
    stitching:"stitching", hornLogo:"horn-logo", adapter:"adapter",
    hubSleeve:"hub-sleeve", columnSpacer:"column-spacer",
    columnSpacerFinish:"column-spacer-finish", careKit:"care-kit"
  };
  var ROLE_SECTIONS = {
    finish:"finish",grip:"grip",leatherWrap:"leather",leatherColor:"leather",
    leatherTemplate:"leather",stitching:"leather",hornLogo:"horn",
    adapter:"mounting",hubSleeve:"mounting",columnSpacer:"accessories",
    columnSpacerFinish:"accessories",careKit:"accessories"
  };
  var sourceGroups = {}, sourceRoots = [], extraFields = new Map();
  var sourceTokens = new WeakMap(), sourceSerial = 0;
  var sharedMounts = {};
  var sharedSettings = window.SPARC_CONFIGURATOR || {};

  function sourceToken(root) {
    if (!root) return "";
    if (!sourceTokens.has(root)) sourceTokens.set(root, "source-" + (++sourceSerial));
    return sourceTokens.get(root);
  }

  function sourceRole(root) {
    var keys=Object.keys(ROLE_NAMES);
    var explicit=keys.find(function(k){
      return root.classList.contains("sparc-role-"+ROLE_NAMES[k]);
    });
    if (explicit) return explicit;
    var configured=keys.find(function(k){
      var ids=sharedSettings.ids && sharedSettings.ids[k];
      return ids && [].concat(ids).indexOf(root.id)!==-1;
    });
    if (configured) return configured;
    // Longest suffix first prevents spacer-finish being mistaken for finish.
    var ordered=keys.slice().sort(function(a,b){return ROLE_NAMES[b].length-ROLE_NAMES[a].length;});
    var matched=ordered.find(function(k){
      return root.id === IDS[k] ||
        new RegExp("^sparc-(?:muscle|shared|heritage|classic|driver|garage)-" + ROLE_NAMES[k] + "(?:$|-)").test(root.id);
    });
    if (matched) return matched;
    var name=q(".hulkapps_option_name",root);
    var label=clean(name && name.getAttribute("aria-label")).toLowerCase();
    if(/^(laser marking\??|horn logo\??)$/.test(label)) return "hornLogo";
    if(/^stitching(?: color)?(?:\??$|\s*[-–—:])/.test(label)) return "stitching";
    return "";
  }

  function refreshRefs() {
    var scope=sourceHost && sourceHost.isConnected ? sourceHost : document;
    sourceRoots=qa(".hulkapps_option",scope).filter(function(n){
      return !panel || !panel.contains(n);
    });
    if(sourceHost && !sourceHost.isConnected && sourceRoots.length) {
      sourceHost=sourceRoots[0].closest(".hulkapps_option_set") || sourceRoots[0].parentElement;
    }
    // Also support fixtures/custom wrappers that carry the established marker.
    qa(".sparc-config-option",scope).forEach(function(n){
      if ((!panel || !panel.contains(n)) && sourceRoots.indexOf(n)<0 &&
          !sourceRoots.some(function(r){return r.contains(n);})) sourceRoots.push(n);
    });
    Object.keys(IDS).forEach(function(k){sourceGroups[k]=[];});
    sourceRoots.forEach(function(root){
      var role=sourceRole(root);
      if(role) sourceGroups[role].push(root);
    });
    Object.keys(IDS).forEach(function(k){
      var active=sourceGroups[k].filter(sourceVisible);
      // Never silently bind one of two simultaneously active alternatives.
      refs[k]=active.length===1 ? active[0] : null;
    });
  }

  function allRefsPresent() {
    refreshRefs();
    return CORE_REF_KEYS.filter(function(k){return !sourceGroups[k].length;});
  }

  function liveSource(root) {
    if(!root) return null;
    refreshRefs();
    var role=sourceRole(root);
    var live=role ? refs[role] : sourceRoots.find(function(n){
      return n===root || (root.getAttribute("data-parent-id") &&
        n.getAttribute("data-parent-id")===root.getAttribute("data-parent-id"));
    });
    // A replaced node of the same Hulk field is safe; a different finish is not.
    if(!live || !sourceVisible(live)) return null;
    if(live!==root && (!root.getAttribute("data-parent-id") || live.getAttribute("data-parent-id")!==root.getAttribute("data-parent-id"))) return null;
    return live;
  }

  function commonAncestor(nodes) {
    nodes = (nodes || []).filter(Boolean);
    if (!nodes.length) return null;

    var p = nodes[0];
    while (p && p !== document.body) {
      if (nodes.every(function(n){ return p.contains(n); })) return p;
      p = p.parentElement;
    }
    return null;
  }

  function containsCoreRef(node) {
    if (!node) return false;

    return CORE_REF_KEYS.some(function(k){
      var core = refs[k] || document.getElementById(IDS[k]);
      return !!(core && core !== node && node.contains(core));
    });
  }

  function compactFieldRootForSelect(sel, labelText) {
    if (!sel) return null;

    var wanted = clean(labelText).toLowerCase();
    var best = sel.parentElement || sel;
    var p = best;

    /* Climb only a few levels and stop at the smallest wrapper that
       contains this single select plus the expected field label. */
    for (var i=0; i<4 && p && p!==document.body; i++,p=p.parentElement) {
      var selectCount = qa("select",p).length;
      var text = clean(p.textContent).toLowerCase();

      if (selectCount === 1 && text.indexOf(wanted) !== -1) {
        best = p;
        break;
      }
    }

    return best;
  }

  function selectOptionText(sel) {
    if (!sel) return "";

    return qa("option",sel)
      .map(function(opt){
        return clean(opt.textContent).toLowerCase();
      })
      .join(" | ");
  }

  function findSelectBySignature(testFn) {
    var scope =
      document.getElementById("ProductSection") ||
      document.querySelector("form[action*='/cart/add']") ||
      document;

    return qa("select",scope).find(function(sel){
      return !!testFn(sel, selectOptionText(sel));
    }) || null;
  }

  function findSpacerFinishRoot() {
    var direct = document.getElementById(IDS.columnSpacerFinish);

    if (direct) {
      var directSelect = sourceSelect(direct);
      if (directSelect) return directSelect;
      if (direct.tagName === "SELECT") return direct;
    }

    var sel = findSelectBySignature(function(node,text){
      var descriptor = clean(
        (node.name || "") + " " +
        (node.id || "") + " " +
        (node.getAttribute("data-name") || "") + " " +
        (node.getAttribute("aria-label") || "")
      ).toLowerCase();

      if (
        /column.*spacer.*finish/.test(descriptor) ||
        text.indexOf("choose column spacer finish") !== -1 ||
        text.indexOf("choose muscle series column spacer finish") !== -1
      ) {
        return true;
      }

      /* Value-signature fallback. This field is uniquely the three
         spacer finishes we created. */
      return (
        text.indexOf("machine finish") !== -1 &&
        text.indexOf("satin black") !== -1 &&
        text.indexOf("polished") !== -1
      );
    });

    if (!sel) return null;

    if (!sel.id) sel.id = IDS.columnSpacerFinish;
    return sel;
  }

  function findCareKitRoot() {
    var direct = document.getElementById(IDS.careKit);

    if (direct) {
      var directSelect = sourceSelect(direct);
      if (directSelect) return directSelect;
      if (direct.tagName === "SELECT") return direct;
    }

    var sel = findSelectBySignature(function(node,text){
      var descriptor = clean(
        (node.name || "") + " " +
        (node.id || "") + " " +
        (node.getAttribute("data-name") || "") + " " +
        (node.getAttribute("aria-label") || "")
      ).toLowerCase();

      return (
        /steering.*wheel.*care.*kit/.test(descriptor) ||
        text.indexOf("choose steering wheel care kit") !== -1
      );
    });

    if (!sel) return null;

    if (!sel.id) sel.id = IDS.careKit;
    return sel;
  }

  function resolveAccessoryRef(key) {
    if (key === "careKit") {
      return findCareKitRoot();
    }

    if (key === "columnSpacerFinish") {
      return findSpacerFinishRoot();
    }

    return document.getElementById(IDS[key]);
  }


  function sourceSelect(root) {
    if (!root) return null;
    if (root.tagName === "SELECT") return root;
    return q("select", root);
  }

  function sourceInputs(root) {
    if (!root) return [];
    if (root.matches && root.matches('input[type="radio"],input[type="checkbox"]')) return [root];
    return qa('input[type="radio"],input[type="checkbox"]', root);
  }

  function sourceVisible(root) {
    if (!root || !root.isConnected) return false;

    /* Hulk is the visibility source of truth. Inspect the source node itself
       and its surrounding condition wrappers. Our offscreen helper classes
       do not use display:none, so they do not interfere with this test. */
    var p = root;

    for (; p && p!==document.body; p=p.parentElement) {
      var s = getComputedStyle(p);

      if (
        s.display === "none" ||
        s.visibility === "hidden" ||
        p.hidden === true ||
        p.getAttribute("aria-hidden") === "true"
      ) {
        return false;
      }
    }

    return true;
  }

  function labelForInput(input, root) {
    if (input && input.id) {
      try {
        var lab = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (lab) return lab;
      } catch(e) {}
    }
    return input ? (input.closest("label") || q("label",root)) : null;
  }

  function choiceContainer(input, root) {
    var p = input;
    for (var i=0;i<5 && p && p!==root;i++,p=p.parentElement) {
      if (q("img",p)) return p;
    }
    return labelForInput(input,root) || (input && input.parentElement);
  }

  function cssUrl(value) {
    if (!value || value === "none") return "";
    var m = String(value).match(/url\((['"]?)(.*?)\1\)/i);
    return m ? m[2] : "";
  }

  function pseudoMediaUrl(node, pseudo) {
    if (!node) return "";

    try {
      var style = getComputedStyle(node, pseudo);
      var bg = style && style.backgroundImage;
      return cssUrl(bg);
    } catch(e) {
      return "";
    }
  }

  function mediaUrl(node) {
    if (!node) return "";

    if (node.tagName === "IMG") {
      return (
        node.currentSrc ||
        node.src ||
        node.getAttribute("data-src") ||
        node.getAttribute("data-lazy-src") ||
        node.getAttribute("data-original") ||
        ""
      );
    }

    var attrs = [
      "data-src",
      "data-image",
      "data-image-url",
      "data-original",
      "data-lazy-src",
      "data-bg",
      "data-background"
    ];

    for (var i=0; i<attrs.length; i++) {
      var val = node.getAttribute && node.getAttribute(attrs[i]);
      if (val && /^https?:|^\/|^\/\//.test(val)) return val;
    }

    var inlineBg = node.style && node.style.backgroundImage;
    var u = cssUrl(inlineBg);
    if (u) return u;

    try {
      u = cssUrl(getComputedStyle(node).backgroundImage);
      if (u) return u;
    } catch(e) {}

    return "";
  }

  function isUtilityIcon(node) {
    var descriptor = (
      (node.className || "") + " " +
      (node.id || "") + " " +
      (node.getAttribute && node.getAttribute("alt") || "") + " " +
      (node.getAttribute && node.getAttribute("title") || "")
    ).toLowerCase();

    return /tooltip|info|question|help|icon-info|fa-info/.test(descriptor);
  }

  function mediaCandidates(scope) {
    if (!scope) return [];

    var nodes = [scope].concat(
      qa("img,[style*='background'],[data-src],[data-image],[data-image-url],[data-original],[data-lazy-src],[data-bg],[data-background]", scope)
    );

    var results = [];

    nodes.forEach(function(node) {
      if (!node || isUtilityIcon(node)) return;

      var urls = [
        mediaUrl(node),
        pseudoMediaUrl(node, "::before"),
        pseudoMediaUrl(node, "::after")
      ].filter(Boolean);

      urls.forEach(function(url) {
        var lower = String(url).toLowerCase();

        /* Never use obvious UI/icon imagery as a product option photo. */
        if (/tooltip|info-icon|question|help-icon|icon-info/.test(lower)) return;

        if (!results.some(function(x){ return x.url === url; })) {
          results.push({ node: node, url: url });
        }
      });
    });

    return results;
  }

  function scopeHasSingleChoice(scope, root) {
    if (!scope) return false;
    var inputs = sourceInputs(scope);
    if (inputs.length === 1) return true;

    /* If the input itself is outside the queried subtree, count only the
       source inputs that also belong to this Hulk option root. */
    var optionInputs = sourceInputs(root);
    var inside = optionInputs.filter(function(input){ return scope.contains(input); });
    return inside.length === 1;
  }

  function exactChoiceScopes(input, root) {
    var scopes = [];

    function add(node) {
      if (!node || node === document.body) return;
      if (scopes.indexOf(node) === -1) scopes.push(node);
    }

    var label = labelForInput(input, root);
    add(label);

    if (input) {
      add(input.parentElement);
      add(input.previousElementSibling);
      add(input.nextElementSibling);

      if (input.parentElement) {
        add(input.parentElement.previousElementSibling);
        add(input.parentElement.nextElementSibling);
      }
    }

    /* Find the smallest ancestor that clearly belongs to ONE Hulk value.
       This is the safest place to look for the uploaded image. */
    var p = input ? input.parentElement : null;
    for (var i=0; i<6 && p && p!==root && p!==document.body; i++, p=p.parentElement) {
      if (scopeHasSingleChoice(p, root)) add(p);
    }

    /* Root is intentionally NOT added as a fallback. Searching the whole
       option root by index is what caused images to shift onto wrong values. */
    return scopes;
  }

  function bestMediaFromScope(scope) {
    var candidates = mediaCandidates(scope);
    if (!candidates.length) return "";

    /* Prefer actual IMG tags or elements with image-ish class names. */
    candidates.sort(function(a,b) {
      function score(item) {
        var node = item.node;
        var s = 0;
        if (node && node.tagName === "IMG") s += 100;

        var desc = (
          (node && node.className || "") + " " +
          (node && node.id || "")
        ).toLowerCase();

        if (/swatch|image|img|option|thumbnail|thumb/.test(desc)) s += 25;

        if (node && node.getBoundingClientRect) {
          var r = node.getBoundingClientRect();
          if (r.width >= 25 && r.height >= 25) s += 10;
        }

        return s;
      }
      return score(b) - score(a);
    });

    return candidates[0].url || "";
  }

  function findMediaForInput(input, root) {
    var scopes = exactChoiceScopes(input, root);

    for (var i=0; i<scopes.length; i++) {
      var url = bestMediaFromScope(scopes[i]);
      if (url) return url;
    }

    return "";
  }

  function findMediaForValue(root, value, index) {
    var inputs = sourceInputs(root);

    if (inputs.length) {
      var input = inputs.find(function(x){
        return String(x.value) === String(value);
      });

      if (input) return findMediaForInput(input, root);
    }

    /* Dropdown-type Hulk options generally do not expose per-value images.
       Do not guess by nearby image order. */
    return "";
  }


  function parsePrice(text) {
    var m = String(text || "").match(/([+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?)/);
    if (!m) return "";
    var s = m[1].replace(/\s+/g,"");
    var amount = parseFloat(s.replace(/[+$,]/g,""));
    if (!isNaN(amount) && amount === 0) return "Included";
    if (s.charAt(0)==="$") s = "+" + s;
    return s;
  }

  function choices(root) {
    if (!root) return [];

    var sel = sourceSelect(root);
    if (sel) {
      return qa("option",sel).filter(function(o){ return o.value!==""; }).map(function(o,index){
        return {
          value:o.value,
          label:o.value,
          price:parsePrice(o.textContent),
          image:findMediaForValue(root,o.value,index),
          disabled:!!(sel.disabled || o.disabled),
          selected:o.selected
        };
      });
    }

    var inputs = sourceInputs(root);

    return inputs.map(function(input,index){
      var c = choiceContainer(input,root);

      return {
        value:input.value,
        label:input.value,
        price:parsePrice(c && c.textContent),
        image:findMediaForValue(root,input.value,index),
        disabled:!!input.disabled,
        selected:!!input.checked
      };
    });
  }

  function current(root) {
    if (!root || !sourceVisible(root)) return "";
    var sel=sourceSelect(root);
    if (sel) return sel.value || "";
    return sourceInputs(root).filter(function(i){return i.checked;}).map(function(i){return i.value;}).join(" · ");
  }

  function setSelectChoice(sel,wanted) {
    if (!sel) return false;

    var wantedNorm = normalizeAccessoryValue(wanted);
    var opts = qa("option",sel);

    var match = opts.find(function(opt){
      return normalizeAccessoryValue(opt.value) === wantedNorm;
    });

    if (!match) {
      match = opts.find(function(opt){
        var txt = normalizeAccessoryValue(opt.textContent);

        return (
          txt === wantedNorm ||
          txt.indexOf(wantedNorm + " ") === 0 ||
          txt.indexOf(wantedNorm + "+") === 0
        );
      });
    }

    if (!match || sel.disabled || match.disabled) return false;

    opts.forEach(function(opt){
      opt.selected = (opt === match);
    });

    sel.selectedIndex = opts.indexOf(match);

    sel.dispatchEvent(
      new Event("input",{bubbles:true})
    );
    sel.dispatchEvent(
      new Event("change",{bubbles:true})
    );

    /* Hulk is commonly loaded with jQuery on this theme. Native events are
       the primary path; this only helps app handlers that subscribed through
       jQuery-specific change hooks. */
    if (
      window.jQuery &&
      typeof window.jQuery === "function"
    ) {
      try {
        window.jQuery(sel).trigger("change");
      } catch(e) {}
    }

    delayedSync();
    return true;
  }

  function choose(root,value) {
    root=liveSource(root);
    if (!root) { queueSync(); return; }
    var sel=sourceSelect(root);
    if (sel) {
      setSelectChoice(sel,value);
      return;
    }
    var input=sourceInputs(root).find(function(x){return String(x.value)===String(value);});
    if (input && !input.disabled) {
      if (input.type === "checkbox" || !input.checked) input.click();
      input.dispatchEvent(new Event("input",{bubbles:true}));
      input.dispatchEvent(new Event("change",{bubbles:true}));
      delayedSync();
    }
  }

  function clearChoice(root) {
    if (!root) return false;

    var sel = sourceSelect(root);
    if (sel) {
      if (!sel.value) return false;

      var blank = qa("option",sel).find(function(o){
        return o.value === "";
      });

      if (blank) {
        sel.value = "";
      } else {
        sel.selectedIndex = -1;
      }

      sel.dispatchEvent(new Event("input",{bubbles:true}));
      sel.dispatchEvent(new Event("change",{bubbles:true}));
      delayedSync();
      return true;
    }

    var changed = false;
    sourceInputs(root).forEach(function(input){
      if (input.checked) {
        input.checked = false;
        changed = true;
        input.dispatchEvent(new Event("input",{bubbles:true}));
        input.dispatchEvent(new Event("change",{bubbles:true}));
      }
    });

    if (changed) delayedSync();
    return changed;
  }

  /* Keep the print-ticket property stable while Hulk's inventory options use
     distinct display/property names. This is informational only: no price,
     variant ID, Hulk option class, or inventory metadata is added here. */
  var LASER_TICKET_NAME = "properties[Laser Marking?]";
  var ticketBridgeError = "";
  var ticketBridgeLastWarning = "";

  function productOptionForm() {
    return (sourceHost && sourceHost.closest("form")) ||
      (refs.finish && refs.finish.closest("form")) || null;
  }

  function hornPropertyName(root) {
    var property=qa("input[name],select[name],textarea[name]",root).find(function(n){
      return /^properties\[(?!_).+\]$/.test(n.name);
    });
    if(property) return property.name;
    var title=q(".hulkapps_option_name",root);
    var label=clean(title && (title.getAttribute("aria-label") || title.textContent));
    return label ? "properties["+label+"]" : "";
  }

  function ticketLogoValue(root) {
    if(!root || !sourceVisible(root)) return "";
    var select=sourceSelect(root);
    var selected=select ? select.options[select.selectedIndex] :
      sourceInputs(root).find(function(n){return n.checked && !n.disabled;});
    if(!selected || selected.disabled || (select && select.disabled)) return "";
    var choice=selected.closest("[data-conditional-value]");
    var value=choice && root.contains(choice) ? choice.getAttribute("data-conditional-value") : selected.value;
    // Preserve spelling/case (Sparc Logo, Sparc Logo Delete, Custom).
    // Unlike friendly(), this does not substitute customer-facing labels.
    return clean(String(value || "")
      .replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g," ")
      .replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g," ")
      .replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g," "));
  }

  function syncLaserMarkingTicket() {
    var groups=sourceGroups.hornLogo || [];
    var form=productOptionForm();
    var mirror=form && q('input[data-sparc-laser-ticket="true"]',form);
    var names=groups.map(hornPropertyName);
    ticketBridgeError="";

    // A wheel with one original Laser Marking? option keeps its native field.
    var nativeTicket=groups.length===1 && names[0]===LASER_TICKET_NAME;
    if(!groups.length || nativeTicket) {
      if(mirror) mirror.remove();
      return true;
    }

    if(names.some(function(n,i){return !n || names.indexOf(n)!==i;}) ||
       names.indexOf(LASER_TICKET_NAME)!==-1) {
      ticketBridgeError="Give every horn inventory option a distinct Hulk Display Name. Reserve Laser Marking? for the ticket bridge; keep Unique Names, IDs, values, conditions, and linked variants unchanged.";
    } else if(!form) {
      ticketBridgeError="The horn options must belong to the product Add to Cart form.";
    } else if(qa("input[name],select[name],textarea[name]",form).some(function(n){
      return n.name===LASER_TICKET_NAME && n!==mirror;
    })) {
      ticketBridgeError="An additional Laser Marking? form property conflicts with the ticket bridge.";
    }

    if(ticketBridgeError) {
      if(mirror) {
        if(mirror.value) mirror.value="";
        if(!mirror.disabled) mirror.disabled=true;
      }
      if(ticketBridgeLastWarning!==ticketBridgeError) {
        console.warn("[SPARC Shared V42.5] "+ticketBridgeError);
        ticketBridgeLastWarning=ticketBridgeError;
      }
      return false;
    }
    ticketBridgeLastWarning="";

    if(!mirror) {
      mirror=document.createElement("input");
      mirror.type="hidden";
      mirror.name=LASER_TICKET_NAME;
      mirror.setAttribute("data-sparc-laser-ticket","true");
      // Outside Hulk's option wrappers so it cannot become a second option.
      form.appendChild(mirror);
    }
    var value=ticketLogoValue(refs.hornLogo);
    if(mirror.value!==value) mirror.value=value;
    if(mirror.disabled!==!value) mirror.disabled=!value;
    return true;
  }

  var STITCH_TICKET_NAME = "properties[Stitching]";
  var stitchTicketError = "";
  var stitchTicketLastWarning = "";

  function syncStitchingTicket() {
    var groups=sourceGroups.stitching || [];
    var form=productOptionForm();
    var mirror=form && q('input[data-sparc-stitch-ticket="true"]',form);
    var names=groups.map(hornPropertyName);
    stitchTicketError="";

    // A wheel with one original Stitching option keeps its native field.
    var nativeTicket=groups.length===1 && names[0]===STITCH_TICKET_NAME;
    if(!groups.length || nativeTicket) {
      if(mirror) mirror.remove();
      return true;
    }

    if(names.some(function(n,i){return !n || names.indexOf(n)!==i;}) ||
       names.indexOf(STITCH_TICKET_NAME)!==-1) {
      stitchTicketError="Give every stitching inventory option a distinct Hulk Display Name. Reserve Stitching for the ticket bridge; keep Unique Names, IDs, values, conditions, and linked variants unchanged.";
    } else if(!form) {
      stitchTicketError="The stitching options must belong to the product Add to Cart form.";
    } else if(qa("input[name],select[name],textarea[name]",form).some(function(n){
      return n.name===STITCH_TICKET_NAME && n!==mirror;
    })) {
      stitchTicketError="An additional Stitching form property conflicts with the ticket bridge.";
    }

    if(stitchTicketError) {
      if(mirror) {
        if(mirror.value) mirror.value="";
        if(!mirror.disabled) mirror.disabled=true;
      }
      if(stitchTicketLastWarning!==stitchTicketError) {
        console.warn("[SPARC Shared V42.5] "+stitchTicketError);
        stitchTicketLastWarning=stitchTicketError;
      }
      return false;
    }
    stitchTicketLastWarning="";

    if(!mirror) {
      mirror=document.createElement("input");
      mirror.type="hidden";
      mirror.name=STITCH_TICKET_NAME;
      mirror.setAttribute("data-sparc-stitch-ticket","true");
      // Outside Hulk's option wrappers so it cannot become a second option.
      form.appendChild(mirror);
    }
    var ready=(!refs.leatherWrap || isYesValue(current(refs.leatherWrap))) &&
      (!(sourceGroups.leatherColor || []).length || !!current(refs.leatherColor));
    var value=ready ? ticketLogoValue(refs.stitching) : "";
    if(mirror.value!==value) mirror.value=value;
    if(mirror.disabled!==!value) mirror.disabled=!value;
    return true;
  }

  /* Hulk may move linked-variant properties onto component lines at checkout.
     Renamed inventory fields opt into these unpriced wheel-line ticket copies.
     Keep legacy single fields native until that option set is migrated. */
  var BUILD_TICKET_FIELDS = {
    finish: "Steering Wheel Finish",
    grip: "Grip Style",
    adapter: "Adapter",
    hubSleeve: "Include Hub Sleeve?"
  };
  var buildTicketErrors = {}, buildTicketLastWarning = "";

  function syncBuildTickets() {
    var form=productOptionForm();
    buildTicketErrors={};
    Object.keys(BUILD_TICKET_FIELDS).forEach(function(role){
      var groups=sourceGroups[role] || [];
      var ticketName="properties["+BUILD_TICKET_FIELDS[role]+"]";
      var mirror=form && q('input[data-sparc-build-ticket="'+role+'"]',form);
      var names=groups.map(hornPropertyName);
      if(!groups.length || (groups.length===1 && names[0]===ticketName)) {
        if(mirror) mirror.remove();
        return;
      }
      var error="";
      if(names.some(function(n,i){return !n || names.indexOf(n)!==i;}) ||
         names.indexOf(ticketName)!==-1) {
        error="Give each "+role+" inventory option a distinct Hulk Display Name. Reserve "+BUILD_TICKET_FIELDS[role]+" for the ticket copy. Keep IDs, values, conditions, and linked variants unchanged.";
      } else if(!form || groups.some(function(root){return root.closest("form")!==form;})) {
        error="The "+role+" inventory options must belong to the product Add to Cart form.";
      } else if(qa("input[name],select[name],textarea[name]",form).some(function(n){
        return n.name===ticketName && n!==mirror;
      })) {
        error="An additional "+BUILD_TICKET_FIELDS[role]+" form property conflicts with the ticket copy.";
      }
      if(error) {
        buildTicketErrors[role]=error;
        if(mirror) {
          if(mirror.value) mirror.value="";
          if(!mirror.disabled) mirror.disabled=true;
        }
        return;
      }
      if(!mirror) {
        mirror=document.createElement("input");
        mirror.type="hidden";
        mirror.name=ticketName;
        mirror.setAttribute("data-sparc-build-ticket",role);
        form.appendChild(mirror);
      }
      // refs contains only the sole currently visible source for each role.
      // No hidden/default value is carried forward after a condition changes.
      var value=ticketLogoValue(refs[role]);
      if(mirror.value!==value) mirror.value=value;
      if(mirror.disabled!==!value) mirror.disabled=!value;
    });
    var warning=Object.keys(buildTicketErrors).map(function(role){return buildTicketErrors[role];}).join(" ");
    if(warning && warning!==buildTicketLastWarning) console.warn("[SPARC Shared V42.5] "+warning);
    buildTicketLastWarning=warning;
    return !warning;
  }

  function orderTicketFields() {
    var form=productOptionForm();
    if(!form) return;
    var fields=[
      ["finish","Steering Wheel Finish"], ["grip","Grip Style"],
      ["leatherWrap","Leather Wrap?"], ["leatherColor","Leather Color"],
      ["stitching","Stitching"], ["leatherTemplate","Leather Template?"],
      ["hornLogo","Laser Marking?"], ["adapter","Adapter"],
      ["hubSleeve","Include Hub Sleeve?"]
    ];
    var anchor=null;
    // Move only our unpriced copies, keeping native controls in their original
    // Hulk wrappers. Native wrap/color/template fields act as ordering anchors.
    // Processing backwards is stable: subsequent syncs cause no DOM changes.
    fields.slice().reverse().forEach(function(field){
      var role=field[0], name="properties["+field[1]+"]";
      var mirror=qa("input[name]",form).find(function(n){
        return n.name===name && (n.hasAttribute("data-sparc-build-ticket") ||
          n.hasAttribute("data-sparc-laser-ticket") || n.hasAttribute("data-sparc-stitch-ticket"));
      });
      if(mirror) {
        var parent=anchor ? anchor.parentNode : form;
        if(mirror.parentNode!==parent || mirror.nextSibling!==anchor) parent.insertBefore(mirror,anchor);
        anchor=mirror;
      } else {
        var native=(sourceGroups[role] || []).find(function(root){
          return root.closest("form")===form && hornPropertyName(root)===name;
        });
        if(native) anchor=native;
      }
    });
  }

  function getState() {
    return {
      finish:current(refs.finish),
      grip:current(refs.grip),
      leatherWrap:current(refs.leatherWrap),
      leatherColor:current(refs.leatherColor),
      leatherTemplate:current(refs.leatherTemplate),
      stitching:current(refs.stitching),
      hornLogo:current(refs.hornLogo),
      adapter:current(refs.adapter),
      hubSleeve:current(refs.hubSleeve),
      columnSpacer:current(refs.columnSpacer),
      columnSpacerFinish:current(refs.columnSpacerFinish),
      careKit:current(refs.careKit)
    };
  }

  /* Robustly use Hulk's actual total anywhere on the page. */
  function configuredPrice() {
    var txt = (document.body.innerText || "").replace(/\u00a0/g," ");
    var matches = txt.match(/Total price is\s*\$[\d,]+(?:\.\d{2})?/ig);
    if (matches && matches.length) {
      var last = matches[matches.length-1];
      var m = last.match(/\$[\d,]+(?:\.\d{2})?/);
      if (m) return m[0];
    }
    return "—";
  }

  /* ==========================================================
     SPARC LEAD-TIME METAOBJECT ENGINE
     Source of truth: Shopify metaobjects emitted by Liquid.
     ========================================================== */

  function leadDebugEnabled() {
    try {
      return (
        new URLSearchParams(window.location.search)
          .get("sparc_lead_debug") === "1"
      );
    } catch (e) {
      return false;
    }
  }

  function ruleDebugRow(rule) {
    if (!rule) return null;

    return {
      ruleName: rule.ruleName,
      scope: rule.seriesScope,
      productHandle: rule.productHandle,
      selectorId: rule.selectorId,
      optionValue: rule.optionValue,
      normalizedValue: normalizeRuleValue(rule.optionValue),
      minimum: rule.minimum,
      maximum: rule.maximum,
      unit: rule.unit,
      customerMessage: rule.customerMessage,
      valid: validLeadRule(rule)
    };
  }

  var leadTimeDataCache = null;
  var leadTimeDataMissingLogged = false;

  function leadTimeData() {
    if (leadTimeDataCache) return leadTimeDataCache;

    var node = document.getElementById(
      "sparc-configurator-lead-time-data"
    );

    if (!node) {
      if (!leadTimeDataMissingLogged) {
        leadTimeDataMissingLogged = true;
        console.warn(
          "[SPARC Shared V42.5] Lead-time JSON bridge was not found on the page."
        );
      }
      return null;
    }

    try {
      leadTimeDataCache = JSON.parse(node.textContent || "{}");
      return leadTimeDataCache;
    } catch (e) {
      console.error(
        "[SPARC Shared V42.5] Lead-time JSON could not be parsed.",
        e
      );
      return null;
    }
  }

  function normalizeLeadUnit(unit) {
    var u = String(unit || "").trim().toLowerCase();

    if (u === "day" || u === "days") return "days";
    if (u === "week" || u === "weeks" || u === "wk" || u === "wks") {
      return "weeks";
    }

    return "";
  }

  function normalizeSelectorId(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .trim()
      .toLowerCase();
  }

  function normalizeRuleValue(value) {
    if (value === null || value === undefined) return "";

    var text = String(value)
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ");

    /* Apply our existing friendly names first. */
    text = friendly(text);

    /* Hulk can decorate values in several formats. Remove ANY price-looking
       fragment rather than relying on one exact decoration pattern. */
    text = String(text)
      .replace(/[[(|]?\s*[+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?\s*[\])|]?/g, " ")
      .replace(/\s+[+\-]\s*[\d,]+(?:\.\d{1,2})?\s*$/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    /* Normalize common punctuation that Hulk can inject between label parts. */
    text = text
      .replace(/\s*[|•·]\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return text;
  }

  function ruleValueMatches(ruleValue, selectedValue) {
    var rule = normalizeRuleValue(ruleValue);
    var selected = normalizeRuleValue(selectedValue);

    if (!rule || !selected) return false;
    if (rule === selected) return true;

    /* Defensive fallback for Hulk strings that retain non-price decoration.
       Only accept a boundary-prefixed match, never arbitrary substring. */
    if (
      selected.indexOf(rule + " ") === 0 ||
      selected.indexOf(rule + " -") === 0 ||
      selected.indexOf(rule + ":") === 0
    ) {
      return true;
    }

    return false;
  }

  function ruleComparisonDays(rule) {
    var unit = normalizeLeadUnit(rule && rule.unit);
    var min = Number(rule && rule.minimum) || 0;
    var max = Number(rule && rule.maximum) || 0;

    if (unit === "weeks") {
      min *= 7;
      max *= 7;
    }

    return {
      min: min,
      max: max
    };
  }

  function validLeadRule(rule) {
    if (!rule) return false;

    var unit = normalizeLeadUnit(rule.unit);
    var min = Number(rule.minimum);
    var max = Number(rule.maximum);

    return !!(
      unit &&
      isFinite(min) &&
      isFinite(max) &&
      min >= 0 &&
      max >= min
    );
  }

  function ruleSpecificity(rule, data) {
    if (!rule || !data) return -1;

    var scope = String(rule.seriesScope || "").toLowerCase();
    var productHandle = String(rule.productHandle || "");

    /* Highest priority: exact product reference. */
    if (
      productHandle &&
      productHandle === String(data.productHandle || "")
    ) {
      return 300;
    }

    /* Series-specific rule. */
    if (
      scope &&
      scope === String(data.seriesScope || "").toLowerCase()
    ) {
      return 200;
    }

    /* Shared rule. */
    if (scope === "shared") {
      return 100;
    }

    return -1;
  }

  function matchingRule(selectorId, optionValue) {
    var data = leadTimeData();
    if (!data || !Array.isArray(data.rules)) return null;

    var selector = normalizeSelectorId(selectorId);

    var selectorRules = data.rules.filter(function(rule) {
      if (!validLeadRule(rule)) return false;

      return (
        normalizeSelectorId(rule.selectorId) === selector &&
        ruleSpecificity(rule, data) >= 0
      );
    });

    var matches = selectorRules.filter(function(rule) {
      return ruleValueMatches(rule.optionValue, optionValue);
    });

    if (!matches.length) {
      if (leadDebugEnabled()) {
        console.warn(
          "[SPARC Shared V42.5] No rule match",
          {
            selectorId: selectorId,
            selectedValue: optionValue,
            normalizedSelector: selector,
            normalizedSelectedValue: normalizeRuleValue(optionValue),
            candidateRules: selectorRules.map(function(rule) {
              return {
                ruleName: rule.ruleName,
                selectorId: rule.selectorId,
                optionValue: rule.optionValue,
                normalizedOptionValue: normalizeRuleValue(rule.optionValue),
                min: rule.minimum,
                max: rule.maximum,
                unit: rule.unit
              };
            })
          }
        );
      }

      return null;
    }

    matches.sort(function(a, b) {
      return (
        ruleSpecificity(b, data) -
        ruleSpecificity(a, data)
      );
    });

    return matches[0];
  }

  function baseLeadRule() {
    return matchingRule("base", "base");
  }

  function activeLeadSelections(s) {
    var selections = [];

    function push(selectorId, value) {
      if (!value) return;

      selections.push({
        selectorId: selectorId,
        value: value
      });
    }

    push(refs.finish ? refs.finish.id : IDS.finish, s.finish);
    push(refs.grip ? refs.grip.id : IDS.grip, s.grip);
    push(refs.leatherWrap ? refs.leatherWrap.id : IDS.leatherWrap, s.leatherWrap);

    if (refs.leatherColor && sourceVisible(refs.leatherColor)) {
      push(refs.leatherColor ? refs.leatherColor.id : IDS.leatherColor, s.leatherColor);
    }

    if (refs.stitching && sourceVisible(refs.stitching)) {
      push(refs.stitching ? refs.stitching.id : IDS.stitching, s.stitching);
    }

    if (refs.leatherTemplate && sourceVisible(refs.leatherTemplate)) {
      push(refs.leatherTemplate ? refs.leatherTemplate.id : IDS.leatherTemplate, s.leatherTemplate);
    }

    push(refs.hornLogo ? refs.hornLogo.id : IDS.hornLogo, s.hornLogo);
    push(refs.adapter ? refs.adapter.id : IDS.adapter, s.adapter);

    if (refs.hubSleeve && sourceVisible(refs.hubSleeve)) {
      push(refs.hubSleeve ? refs.hubSleeve.id : IDS.hubSleeve, s.hubSleeve);
    }

    if (refs.columnSpacer && sourceVisible(refs.columnSpacer)) {
      push(refs.columnSpacer ? refs.columnSpacer.id : IDS.columnSpacer, s.columnSpacer);
    }

    if (refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish)) {
      push(refs.columnSpacerFinish ? refs.columnSpacerFinish.id : IDS.columnSpacerFinish, s.columnSpacerFinish);
    }

    if (
      refs.careKit &&
      sourceVisible(refs.careKit) &&
      valueEquals(s.careKit, "Yes")
    ) {
      push(refs.careKit ? refs.careKit.id : IDS.careKit, s.careKit);
    }

    extraFields.forEach(function(entry,root){
      if(sourceVisible(root)) push(root.id,current(root));
    });
    return selections;
  }

  function activeLeadMessages(s) {
    var data=leadTimeData();

    if (!data || !Array.isArray(data.rules)) {
      return [];
    }

    var selections=activeLeadSelections(s);
    var messages=[];

    function addMessage(rule) {
      if (!rule) return;

      var message=clean(rule.customerMessage || "");
      if (!message) return;

      if (messages.indexOf(message) === -1) {
        messages.push(message);
      }
    }

    selections.forEach(function(selection){
      var selector=
        normalizeSelectorId(selection.selectorId);

      data.rules.forEach(function(rule){
        if (!rule) return;
        if (ruleSpecificity(rule,data) < 0) return;

        if (
          normalizeSelectorId(rule.selectorId) !== selector
        ) return;

        if (
          !ruleValueMatches(
            rule.optionValue,
            selection.value
          )
        ) return;

        addMessage(rule);
      });
    });

    data.rules.forEach(function(rule){
      if (!rule) return;
      if (ruleSpecificity(rule,data) < 0) return;

      if (
        normalizeSelectorId(rule.selectorId) ===
          normalizeSelectorId("base") &&
        ruleValueMatches(rule.optionValue,"base")
      ) {
        addMessage(rule);
      }
    });

    /* Muscle Customer Supplied Leather can be surfaced by Hulk/SPARC as
       either "Customer Supplied" or "Customer Supplied Leather".
       Keep numerical rule matching unchanged, but allow a relevant shared
       customer-message rule to qualify the lead time whenever the selected
       Muscle leather color is clearly Customer Supplied. */
    if (
      refs.leatherColor &&
      sourceVisible(refs.leatherColor) &&
      normalizeRuleValue(s.leatherColor)
        .indexOf("customer supplied") !== -1
    ) {
      data.rules.forEach(function(rule){
        if (!rule) return;

        var scope=
          String(rule.seriesScope || "")
            .trim()
            .toLowerCase();

        if (
          scope !== "shared" &&
          scope !== "muscle"
        ) {
          return;
        }

        if (
          normalizeRuleValue(rule.optionValue)
            .indexOf("customer supplied") === -1
        ) {
          return;
        }

        addMessage(rule);
      });
    }

    return messages;
  }

  function leadQualifier(s) {
    return activeLeadMessages(s).join(" • ");
  }

  function winningLeadRule(s) {
    var candidates = [];

    var base = baseLeadRule();
    if (base) candidates.push(base);

    activeLeadSelections(s).forEach(function(selection) {
      var rule = matchingRule(
        selection.selectorId,
        selection.value
      );

      if (rule) candidates.push(rule);
    });

    if (!candidates.length) return null;

    candidates.sort(function(a, b) {
      var ac = ruleComparisonDays(a);
      var bc = ruleComparisonDays(b);

      /* Longest maximum wins. */
      if (bc.max !== ac.max) {
        return bc.max - ac.max;
      }

      /* Tie-breaker: longest minimum wins. */
      if (bc.min !== ac.min) {
        return bc.min - ac.min;
      }

      /* Final tie-breaker: most specific rule wins. */
      return (
        ruleSpecificity(b, leadTimeData()) -
        ruleSpecificity(a, leadTimeData())
      );
    });

    return candidates[0];
  }

  function formatLeadRule(rule) {
    if (!validLeadRule(rule)) return "—";

    var min = Number(rule.minimum);
    var max = Number(rule.maximum);
    var unit = normalizeLeadUnit(rule.unit);

    if (unit === "days") {
      if (min === max) {
        return min === 1 ? "1 DAY" : min + " DAYS";
      }

      return min + "–" + max + " DAYS";
    }

    if (unit === "weeks") {
      if (min === max) {
        return min === 1 ? "1 WK" : min + " WKS";
      }

      return min + "–" + max + " WKS";
    }

    return "—";
  }

  function leadTime(s) {
    var winner = winningLeadRule(s);

    if (winner) {
      return formatLeadRule(winner);
    }

    /* Safety fallback only if Liquid/metaobject data is unavailable.
       This should disappear in normal operation once the Base rule exists. */
    if (leadTimeData()) {
      console.warn(
        "[SPARC Shared V42.5] Lead-time rules loaded, but no applicable rule was found. " +
        "Check the active Muscle Series Base metaobject."
      );
    }

    return "3–5 DAYS";
  }

  function renderLeadDebug() {
    if (!leadDebugEnabled()) return;

    var existing = document.getElementById("sparc-lead-debug");

    if (existing) existing.remove();

    var data = leadTimeData();
    var state = getState();
    var selections = activeLeadSelections(state);

    var box = el("div", "");
    box.id = "sparc-lead-debug";
    box.style.cssText =
      "margin:12px 0;padding:12px 14px;border:2px solid #a8874a;" +
      "background:#fff8ea;color:#222;font:11px/1.45 Arial,sans-serif;";

    var html = "<strong>SPARC V36 Lead-Time Debug</strong>";

    if (!data) {
      html += "<br><br><b>ERROR:</b> Lead-time JSON bridge is missing from the page.";
    }

    html += "<br><br><b>Winning rule:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(ruleDebugRow(winningLeadRule(state)), null, 2)
        .replace(/</g,"&lt;") +
      "</pre>";

    html += "<b>Active selections:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(
        selections.map(function(sel) {
          var matched = matchingRule(sel.selectorId, sel.value);

          return {
            selectorId: sel.selectorId,
            rawValue: sel.value,
            normalizedValue: normalizeRuleValue(sel.value),
            matchedRule: matched ? ruleDebugRow(matched) : null
          };
        }),
        null,
        2
      ).replace(/</g,"&lt;") +
      "</pre>";

    html += "<b>Loaded rules:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(
        data && data.rules
          ? data.rules.map(ruleDebugRow)
          : [],
        null,
        2
      ).replace(/</g,"&lt;") +
      "</pre>";

    box.innerHTML = html;

    var mount = document.getElementById("sparc-muscle-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }
  }

  function currentLeadTimeRule() {
    return winningLeadRule(getState());
  }



  /* ==========================================================
     SPARC OPTION DETAIL METAOBJECT ENGINE V38
     Source of truth: Shopify metaobjects emitted by Liquid.
     ========================================================== */

  var optionDetailDataCache = null;

  function optionDetailData() {
    if (optionDetailDataCache) return optionDetailDataCache;

    var node = document.getElementById(
      "sparc-configurator-option-detail-data"
    );

    if (!node) {
      return null;
    }

    try {
      optionDetailDataCache = JSON.parse(node.textContent || "{}");
      return optionDetailDataCache;
    } catch (e) {
      console.error(
        "[SPARC Shared V42.5] Option-detail JSON could not be parsed.",
        e
      );
      return null;
    }
  }

  function optionDetailSpecificity(detail, data) {
    if (!detail || !data) return -1;

    var scope = String(detail.seriesScope || "").toLowerCase();
    var productHandle = String(detail.productHandle || "");

    if (
      productHandle &&
      productHandle === String(data.productHandle || "")
    ) {
      return 300;
    }

    if (
      scope &&
      scope === String(data.seriesScope || "").toLowerCase()
    ) {
      return 200;
    }

    if (scope === "shared") {
      return 100;
    }

    return -1;
  }

  function matchingOptionDetail(selectorId, optionValue) {
    var data = optionDetailData();

    if (!data || !Array.isArray(data.entries)) {
      return null;
    }

    var selector = normalizeSelectorId(selectorId);

    var matches = data.entries.filter(function(detail) {
      if (!detail || detail.enabled !== true) return false;

      if (
        normalizeSelectorId(detail.selectorId) !== selector
      ) {
        return false;
      }

      if (
        !ruleValueMatches(detail.optionValue, optionValue)
      ) {
        return false;
      }

      return optionDetailSpecificity(detail, data) >= 0;
    });

    if (!matches.length) return null;

    matches.sort(function(a,b) {
      return (
        optionDetailSpecificity(b,data) -
        optionDetailSpecificity(a,data)
      );
    });

    return matches[0];
  }

  function selectorImageForOption(root, value, fallbackImage) {
    var detail = matchingOptionDetail(
      root && root.id,
      value
    );

    /* Hulk image swatches are the normal card-image source of truth.
       Option Detail selectorImage remains a fallback for legacy entries. */
    return (
      fallbackImage ||
      (detail && detail.selectorImage) ||
      ""
    );
  }

  function popupImagesForOption(root, value, fallbackImage) {
    var detail = matchingOptionDetail(
      root && root.id,
      value
    );

    var images = [];

    if (detail && detail.popupImage) {
      images.push(detail.popupImage);
    } else if (detail && detail.selectorImage) {
      images.push(detail.selectorImage);
    } else if (fallbackImage) {
      images.push(fallbackImage);
    }

    if (
      detail &&
      Array.isArray(detail.popupAdditionalImages)
    ) {
      detail.popupAdditionalImages.forEach(function(url) {
        if (url && images.indexOf(url) === -1) {
          images.push(url);
        }
      });
    }

    return images;
  }

  function accordion(name,num,title) {
    var section=el("section","sparc-accordion");
    section.dataset.section=name;
    var head=el("button","sparc-accordion__head");
    head.type="button";
    head.appendChild(el("span","sparc-step-number",num));
    head.appendChild(el("span","sparc-accordion__title",title));
    head.appendChild(el("span","sparc-required-badge","REQUIRED"));

    head.appendChild(el("span","sparc-accordion__summary",""));
    head.appendChild(el("span","sparc-chevron","⌄"));
    var body=el("div","sparc-accordion__body");
    var inner=el("div","sparc-accordion__inner");
    body.appendChild(inner); section.appendChild(head); section.appendChild(body);

    head.addEventListener("click",function(e){
      e.preventDefault(); e.stopPropagation();
      if(section.classList.contains("is-open")) closeAll();
      else openSection(name);
    });
    return {section:section,inner:inner};
  }

  function makeTab(name,text) {
    var b=el("button","sparc-config-tab",text); b.type="button";
    b.addEventListener("click",function(e){
      e.preventDefault(); e.stopPropagation(); openSection(name);
    });
    tabs[name]=b;
    return b;
  }

  function closeAll() {
    Object.keys(accs).forEach(function(k){ if(accs[k].section) accs[k].section.classList.remove("is-open"); });
    Object.keys(tabs).forEach(function(k){ tabs[k].classList.remove("is-active"); });
    scheduleResize();
  }

  function openSection(name) {
    Object.keys(accs).forEach(function(k){ if(accs[k].section) accs[k].section.classList.toggle("is-open",k===name); });
    Object.keys(tabs).forEach(function(k){ tabs[k].classList.toggle("is-active",k===name); });
    scheduleResize();
  }


  function optionInfoCopy(sectionName, value) {
    var val = friendly(value);

    if (sectionName === "finish") {
      return "See a larger view of " + val + " and compare how this finish changes the appearance of the billet center and spokes.";
    }

    if (sectionName === "grip") {
      return "See a larger view of the " + val + " grip profile. Use the enlarged image to compare the hand position, upper-grip geometry, and overall shape.";
    }

    if (sectionName === "leather") {
      return "See more detail for " + val + ". Leather and grip-finish selections affect both the appearance and final feel of the steering wheel.";
    }

    if (sectionName === "horn") {
      return "See more detail for the " + val + " horn-button treatment and how it affects the finished center appearance.";
    }

    if (sectionName === "mounting") {
      return "See more information about " + val + " and how this mounting choice relates to steering-column fitment.";
    }

    if (sectionName === "accessories") {
      return "See more information about " + val + ", including fitment, finish, and how this optional accessory works with your steering wheel package.";
    }

    return "More information about " + val + ".";
  }

  function sectionNameForRoot(root) {
    if (root === refs.finish) return "finish";
    if (root === refs.grip) return "grip";
    if (root === refs.leatherWrap || root === refs.leatherColor) return "leather";
    if (root === refs.hornLogo) return "horn";
    if (root === refs.adapter || root === refs.hubSleeve) return "mounting";
    if (
      root === refs.columnSpacer ||
      root === refs.columnSpacerFinish ||
      root === refs.careKit
    ) return "accessories";
    return "";
  }

  function addOptionInfoButton(
    container,
    root,
    value,
    imageUrl
  ) {
    if (!container || !root) return;

    var sectionName = sectionNameForRoot(root);

    if (!sectionName) return;

    var button=el(
      "button",
      "sparc-option-info",
      "i"
    );

    button.type="button";
    button.setAttribute(
      "aria-label",
      "More information about " + friendly(value)
    );

    button.addEventListener("click",function(e) {
      e.preventDefault();
      e.stopPropagation();

      var detail = matchingOptionDetail(
        root.id,
        value
      );

      openOptionInfoModal({
        section: sectionName,
        root: root,
        value: value,
        fallbackImage: imageUrl || "",
        detail: detail
      });
    });

    container.appendChild(button);
  }

  function setInfoModalGallery(
    modal,
    images,
    altText
  ) {
    var main = q(
      ".sparc-info-modal__image",
      modal
    );

    var strip = q(
      ".sparc-info-modal__thumbs",
      modal
    );

    images = Array.isArray(images)
      ? images.filter(Boolean)
      : [];

    strip.innerHTML = "";

    if (!images.length) {
      main.removeAttribute("src");
      main.classList.remove("has-image");
      strip.classList.remove("has-images");
      return;
    }

    main.src=images[0];
    main.alt=altText||"";
    main.classList.add("has-image");

    if (images.length > 1) {
      strip.classList.add("has-images");

      images.forEach(function(url,index) {
        var button=el(
          "button",
          "sparc-info-modal__thumb",
          ""
        );

        button.type="button";
        button.classList.toggle(
          "is-active",
          index===0
        );

        var img=document.createElement("img");
        img.src=url;
        img.alt=
          altText
            ? altText + " view " + (index+1)
            : "Option detail view " + (index+1);

        button.appendChild(img);

        button.addEventListener(
          "click",
          function() {
            main.src=url;

            qa(
              ".sparc-info-modal__thumb",
              strip
            ).forEach(function(node) {
              node.classList.remove(
                "is-active"
              );
            });

            button.classList.add(
              "is-active"
            );
          }
        );

        strip.appendChild(button);
      });
    } else {
      strip.classList.remove("has-images");
    }
  }

  function openOptionInfoModal(data) {
    var modal=ensureInfoModal();

    var sectionContent=
      INFO_CONTENT[data.section]||{};

    var detail=
      data.detail ||
      matchingOptionDetail(
        data.root && data.root.id,
        data.value
      );

    q(
      ".sparc-info-modal__eyebrow",
      modal
    ).textContent=
      sectionContent.eyebrow ||
      "Option Information";

    q(
      ".sparc-info-modal__title",
      modal
    ).textContent=
      detail && detail.popupTitle
        ? detail.popupTitle
        : friendly(data.value);

    q(
      ".sparc-info-modal__selection",
      modal
    ).textContent=
      detail && detail.popupDescriptionHeading
        ? detail.popupDescriptionHeading
        : "OPTION DETAILS";

    var copy=q(
      ".sparc-info-modal__copy",
      modal
    );

    if (
      detail &&
      detail.popupDescriptionHtml
    ) {
      copy.innerHTML=
        detail.popupDescriptionHtml;
    } else {
      copy.textContent=
        optionInfoCopy(
          data.section,
          data.value
        );
    }

    var images=popupImagesForOption(
      data.root,
      data.value,
      data.fallbackImage
    );

    setInfoModalGallery(
      modal,
      images,
      detail && detail.imageAltText
        ? detail.imageAltText
        : friendly(data.value)
    );

    modal.classList.add("is-open");
    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.classList.add(
      "sparc-modal-open"
    );
  }

  function cardGrid(root,cols,isGrip,placeholder) {
    var wrap=el(
      "div",
      "sparc-card-grid " +
      (cols===3?"sparc-card-grid--3":"sparc-card-grid--2")
    );

    choices(root).forEach(function(c) {
      var detail = matchingOptionDetail(root.id,c.value);
      var cardImage = selectorImageForOption(
        root,
        c.value,
        c.image
      );

      var b=el("button","sparc-option-card");
      b.type="button";
      b.dataset.value=c.value;
      b.dataset.sourceId=root.id;
      b.disabled=!!c.disabled;

      b.appendChild(
        el("span","sparc-option-card__check","✓")
      );

      addOptionInfoButton(
        b,
        root,
        c.value,
        cardImage
      );

      var iw=el(
        "div",
        "sparc-option-card__image" +
        (isGrip?" sparc-option-card__image--grip":"")
      );

      if(cardImage) {
        var im=document.createElement("img");
        im.src=cardImage;
        im.alt=
          detail && detail.imageAltText
            ? detail.imageAltText
            : friendly(c.value);
        iw.appendChild(im);
      } else {
        iw.appendChild(
          el(
            "div",
            "sparc-option-card__placeholder",
            placeholder ||
            "Add option image in Hulk Admin"
          )
        );
      }

      b.appendChild(iw);

      var cp=el("div","sparc-option-card__copy");
      cp.appendChild(
        el(
          "span",
          "sparc-option-card__name",
          friendly(c.value)
        )
      );

      var meta=el("div","sparc-option-card__meta");
      meta.appendChild(
        el("span","sparc-option-card__note","")
      );
      meta.appendChild(
        el(
          "span",
          "sparc-option-card__price",
          c.price||""
        )
      );

      cp.appendChild(meta);
      b.appendChild(cp);

      b.addEventListener("click",function(e) {
        e.preventDefault();
        e.stopPropagation();
        choose(root,c.value);
      });

      wrap.appendChild(b);
    });

    return wrap;
  }

  function optionalAccessoryToggleCard(root,yesValue,noValue,title,description) {
    var wrap=el("div","sparc-accessory-toggle-grid");
    var yesChoice=choices(root).find(function(c){
      return valueEquals(c.value,yesValue);
    });

    if (!yesChoice) return wrap;

    var detail = matchingOptionDetail(root.id,yesChoice.value);
    var cardImage = selectorImageForOption(
      root,
      yesChoice.value,
      yesChoice.image
    );

    var button=el("button","sparc-option-card sparc-accessory-toggle-card");
    button.type="button";
    button.dataset.value=yesChoice.value;
    button.dataset.sourceId=root.id;

    button.appendChild(
      el("span","sparc-option-card__check","✓")
    );

    addOptionInfoButton(
      button,
      root,
      yesChoice.value,
      cardImage
    );

    var iw=el("div","sparc-option-card__image sparc-accessory-toggle-card__image");

    if(cardImage) {
      var im=document.createElement("img");
      im.src=cardImage;
      im.alt=
        detail && detail.imageAltText
          ? detail.imageAltText
          : title;
      iw.appendChild(im);
    } else {
      iw.appendChild(
        el(
          "div",
          "sparc-option-card__placeholder",
          "Add care kit image in Hulk Admin"
        )
      );
    }

    button.appendChild(iw);

    var cp=el("div","sparc-option-card__copy");
    cp.appendChild(
      el("span","sparc-option-card__name",title)
    );

    if (description) {
      cp.appendChild(
        el("span","sparc-accessory-toggle-card__description",description)
      );
    }

    var meta=el("div","sparc-option-card__meta");
    meta.appendChild(el("span","sparc-option-card__note","Optional"));
    meta.appendChild(
      el("span","sparc-option-card__price",yesChoice.price||"")
    );
    cp.appendChild(meta);
    button.appendChild(cp);

    button.dataset.accessoryKey="careKit";

    button.addEventListener("click",function(e){
      if (e.__sparcCareHandled) return;

      e.preventDefault();
      e.stopPropagation();

      var liveRoot=currentAccessoryRoot("careKit");
      if (!liveRoot) return;

      var nextValue =
        valueEquals(current(liveRoot),yesValue)
          ? noValue
          : yesValue;

      choose(liveRoot,nextValue);

      requestAnimationFrame(function(){
        var currentRoot=currentAccessoryRoot("careKit");
        if (currentRoot) {
          syncChoiceClasses(
            currentRoot,
            accs.accessories.section
          );
        }
      });
    });

    wrap.appendChild(button);
    return wrap;
  }

  function choiceGrid(root,metaMap) {
    var wrap=el("div","sparc-choice-grid");
    choices(root).forEach(function(c){
      var m=(metaMap&&metaMap[c.value])||{};
      var b=el("button","sparc-choice"); b.type="button"; b.dataset.value=c.value; b.dataset.sourceId=root.id; b.disabled=!!c.disabled;
      b.appendChild(el("span","sparc-choice__title",m.title||friendly(c.value)));
      b.appendChild(el("span","sparc-choice__sub",m.sub||c.price||""));
      b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();choose(root,c.value);});
      wrap.appendChild(b);
    });
    return wrap;
  }

  function stitchGrid(root) {
    var wrap=el("div","sparc-stitch-grid");
    var cs=choices(root), commonPrice=cs.length && cs[0].price;
    if(!cs.every(function(c){return c.price===commonPrice;})) commonPrice="";
    cs.forEach(function(c){
      var b=el("button","sparc-stitch"); b.type="button"; b.dataset.value=c.value; b.dataset.sourceId=root.id; b.disabled=!!c.disabled;
      var label=friendly(c.value);
      var colorKey=Object.keys(STITCH_COLORS).find(function(name){return name.toLowerCase()===label.toLowerCase();});
      var t=el("span","sparc-stitch__thread"); t.style.background=STITCH_COLORS[colorKey]||"#777";
      b.appendChild(t); b.appendChild(el("span","sparc-stitch__name",label));
      if(c.price && !commonPrice) b.appendChild(el("span","sparc-stitch__price",c.price));
      b.setAttribute("aria-label",label+(c.price ? ", "+c.price : ""));
      b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();choose(root,c.value);});
      wrap.appendChild(b);
    });
    return wrap;
  }

  function mirrorSelect(root,labelText,help) {
    var field=el("div","sparc-field");
    field.appendChild(el("label","sparc-field__label",labelText));
    var mirror=document.createElement("select"); mirror.className="sparc-select";
    var ss=sourceSelect(root);
    if(ss) {
      qa("option",ss).forEach(function(o){
        var op=document.createElement("option");op.value=o.value;op.textContent=o.textContent;mirror.appendChild(op);
      });
      mirror.value=ss.value;
      mirror.addEventListener("change",function(e){e.stopPropagation();choose(root,mirror.value);});
    }
    field.appendChild(mirror);
    if(help) field.appendChild(el("div","sparc-field__help",help));
    field._mirror=mirror;
    return field;
  }

  function conditional() {
    var o=el("div","sparc-conditional");
    o.appendChild(el("div","sparc-conditional__inner"));
    return o;
  }

  function hideLegacyDecorations() {
    qa("*",document).forEach(function(n){
      if(panel && panel.contains(n)) return;
      if(n.children.length<=1 && /^Choose Your Product Options:?$/i.test(clean(n.textContent))) {
        n.classList.add("sparc-source-decoration-hidden");
      }
      if(n.children.length<=3 && /^Total price is\s*\$[\d,]+(?:\.\d{2})?$/i.test(clean(n.textContent))) {
        n.classList.add("sparc-source-decoration-hidden");
      }
    });
  }


  function debugImageData() {
    var params = new URLSearchParams(window.location.search);
    if (params.get("sparc_debug") !== "1") return;

    var old = document.getElementById("sparc-image-debug");
    if (old) old.remove();

    var box = el("div", "");
    box.id = "sparc-image-debug";

    function rows(root, title) {
      var html = "<strong>" + title + "</strong>";
      var ch = choices(root);
      var inputs = sourceInputs(root);

      ch.forEach(function(c) {
        var input = inputs.find(function(x){
          return String(x.value) === String(c.value);
        });

        var label = input ? labelForInput(input, root) : null;

        html += "<code>" +
          c.value.replace(/</g,"&lt;") +
          " -> " +
          (c.image ? c.image.replace(/</g,"&lt;") : "[NO EXACT IMAGE URL FOUND]") +
          "</code><br>";

        if (!c.image && label) {
          var snippet = label.outerHTML || "";
          snippet = snippet.slice(0,900)
            .replace(/&/g,"&amp;")
            .replace(/</g,"&lt;")
            .replace(/>/g,"&gt;");

          html += "<code>label HTML: " + snippet + "</code><br>";
        }
      });

      return html;
    }

    box.innerHTML =
      "<b>SPARC V23 Exact Hulk Image Debug</b>" +
      rows(refs.finish,"Finish") +
      rows(refs.grip,"Grip") +
      rows(refs.leatherColor,"Leather Color");

    var mount = document.getElementById("sparc-muscle-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }

    console.info("[SPARC Shared V42.5] Finish media", choices(refs.finish));
    console.info("[SPARC Shared V42.5] Grip media", choices(refs.grip));
    console.info("[SPARC Shared V42.5] Leather Color media", choices(refs.leatherColor));
  }


  function findCustomLaserFileSource() {
    var files = qa('input[type="file"]', document).filter(function(input) {
      return !input.classList.contains("sparc-custom-upload__input");
    });

    if (!files.length) return null;

    var candidates = files.map(function(input) {
      var score = 0;
      var p = input.parentElement;
      var bestWrapper = input.parentElement;

      var descriptor = clean(
        (input.name || "") + " " +
        (input.id || "") + " " +
        (input.className || "") + " " +
        (input.getAttribute("data-name") || "") + " " +
        (input.getAttribute("data-label") || "")
      ).toLowerCase();

      if (/custom laser marking/.test(descriptor)) score += 200;
      if (/laser|marking/.test(descriptor)) score += 90;
      if (/custom|logo/.test(descriptor)) score += 50;

      for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
        var text = clean(p.textContent).toLowerCase();

        if (/custom laser marking/.test(text)) score += 180;
        else if (/laser.*mark|custom.*mark/.test(text)) score += 100;
        else if (/laser|marking|custom logo/.test(text)) score += 35;

        if (
          bestWrapper &&
          clean(p.textContent).length &&
          clean(p.textContent).length < clean(bestWrapper.textContent).length
        ) {
          bestWrapper = p;
        }
      }

      return {
        input: input,
        wrapper: bestWrapper || input.parentElement,
        score: score
      };
    });

    candidates.sort(function(a,b){ return b.score - a.score; });

    if (candidates[0] && (candidates[0].score > 0 || files.length === 1)) {
      return candidates[0];
    }

    return null;
  }

  function customUploadBlock() {
    var outer = el("div", "sparc-custom-upload is-hidden");

    outer.appendChild(
      el(
        "span",
        "sparc-custom-upload__label",
        "CUSTOM HORN LOGO ARTWORK"
      )
    );

    outer.appendChild(
      el(
        "div",
        "sparc-custom-upload__help",
        "Upload the artwork file SPARC should use for your custom horn-button laser marking. Vector artwork is preferred when available."
      )
    );

    var input = document.createElement("input");
    input.type = "file";
    input.className = "sparc-custom-upload__input";
    input.accept = ".ai,.eps,.svg,.pdf,.png,.jpg,.jpeg";

    var status = el(
      "div",
      "sparc-custom-upload__status",
      "No file selected"
    );

    outer.appendChild(input);
    outer.appendChild(status);

    outer._sparcProxyInput = input;
    outer._sparcStatus = status;
    outer._sparcProxyFile = null;
    outer._sparcFileInput = null;
    outer._sparcSourceWrapper = null;

    input.addEventListener("change", function() {
      outer._sparcProxyFile =
        input.files && input.files.length
          ? input.files[0]
          : null;

      status.classList.remove("is-ok","is-error");

      if (!outer._sparcProxyFile) {
        status.textContent = "No file selected";
        if (sparcValidationAttempted) applyValidationState();
        return;
      }

      status.textContent = outer._sparcProxyFile.name;

      function finishStatus(ok) {
        status.classList.remove("is-ok","is-error");

        if (ok) {
          status.classList.add("is-ok");
          status.textContent = outer._sparcProxyFile.name + " · ready";
        } else {
          status.textContent = outer._sparcProxyFile.name + " · connecting to product upload field…";
        }

        if (sparcValidationAttempted) applyValidationState();
      }

      var synced = syncProxyFileToHulk();
      finishStatus(synced);

      if (!synced) {
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },150);
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },500);
        setTimeout(function(){ finishStatus(syncProxyFileToHulk()); },1000);
      }
    });

    return outer;
  }

  function customFileVisualWrapper(input) {
    if (!input) return null;

    var p = input.parentElement;
    var fallback = p;

    for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
      var text = clean(p.textContent);

      if (/Custom Laser Marking/i.test(text)) {
        return p;
      }

      /* Keep a reasonable wrapper fallback containing the input. */
      if (p.contains(input)) fallback = p;
    }

    return fallback;
  }

  function setInputFiles(input, file) {
    if (!input || !file) return false;

    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;

      input.dispatchEvent(new Event("input",{bubbles:true}));
      input.dispatchEvent(new Event("change",{bubbles:true}));

      return !!(
        input.files &&
        input.files.length &&
        input.files[0].name === file.name
      );
    } catch(e) {
      console.warn("[SPARC Shared V42.5] Could not mirror file into Hulk input", e);
      return false;
    }
  }

  function syncProxyFileToHulk() {
    if (!accs.customLaserBlock) return false;

    var file = accs.customLaserBlock._sparcProxyFile;

    if (!file) return false;

    var source = findCustomLaserFileSource();

    if (!source || !source.input) return false;

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    var ok = setInputFiles(input,file);

    var status = accs.customLaserBlock._sparcStatus;

    if (status) {
      status.classList.remove("is-ok","is-error");

      if (ok) {
        status.classList.add("is-ok");
        status.textContent = file.name + " · ready";
      } else {
        status.classList.add("is-error");
        status.textContent = file.name + " · upload field not ready";
      }
    }

    return ok;
  }

  /* V33: intentionally no document-wide MutationObserver.
     Continuous observation of Hulk's conditional file field caused browser
     instability when Custom was selected. We use finite retries instead. */
  function watchForCustomUpload() {
    return;
  }


  function connectCustomLaserUpload() {
    if (!accs.customLaserBlock) return false;

    var source = findCustomLaserFileSource();

    if (!source || !source.input) return false;

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    return true;
  }


  function adapterSvg(label) {
    var years = String(label || "").match(/\d{2}[-–]\d{2}/);
    var yr = years ? years[0] : "";

    return (
      '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<circle cx="50" cy="50" r="31" stroke-width="5"/>' +
        '<circle cx="50" cy="50" r="13" stroke-width="4"/>' +
        '<path d="M50 19V36M50 64V81M19 50H36M64 50H81" stroke-width="4" stroke-linecap="round"/>' +
        '<path d="M30 30L41 41M59 59L70 70M70 30L59 41M41 59L30 70" stroke-width="3" stroke-linecap="round"/>' +
        (yr ? '<text x="50" y="96" text-anchor="middle" fill="#55514b" stroke="none" font-size="12" font-family="Arial" font-weight="700">' + yr + '</text>' : '') +
      '</svg>'
    );
  }

  function isYesValue(value) {
    return /^yes\b/i.test(clean(value));
  }

  function sleeveSvg(hasSleeve) {
    if (!hasSleeve) {
      return (
        '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<ellipse cx="50" cy="32" rx="24" ry="10" stroke-width="4"/>' +
          '<path d="M26 32V67C26 73 37 78 50 78C63 78 74 73 74 67V32" stroke-width="4"/>' +
          '<ellipse cx="50" cy="67" rx="24" ry="10" stroke-width="4"/>' +
          '<path d="M23 23L77 77" stroke="#9c2e24" stroke-width="7" stroke-linecap="round"/>' +
        '</svg>'
      );
    }

    return (
      '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<ellipse cx="50" cy="25" rx="25" ry="11" stroke-width="4"/>' +
        '<path d="M25 25V70C25 77 36 83 50 83C64 83 75 77 75 70V25" stroke-width="4"/>' +
        '<ellipse cx="50" cy="70" rx="25" ry="11" stroke-width="4"/>' +
        '<ellipse cx="50" cy="25" rx="12" ry="5" stroke-width="3"/>' +
      '</svg>'
    );
  }

  function visualMountingGrid(root, kind) {
    /* Match Driver: Hulk supplies the image swatch and the standard SPARC
       image-card component presents Adapter / Hub Sleeve consistently. */
    var grid = cardGrid(root, 2, false);

    if (kind === "adapter") {
      grid.classList.add("sparc-muscle-adapter-mount");
    } else if (kind === "sleeve") {
      grid.classList.add("sparc-muscle-hub-sleeve-mount");
    }

    return grid;
  }

  var INFO_CONTENT = {
    finish: {
      eyebrow: "01 · Finish",
      title: "Steering Wheel Finish",
      copy: "Choose the appearance of the billet center and spoke assembly. The larger view helps compare the selected finish and the visual character it gives the steering wheel."
    },
    grip: {
      eyebrow: "02 · Grip",
      title: "Grip Style",
      copy: "The grip profile changes the shape and feel of the steering wheel in your hands. Compare the four available grip geometries in the larger view before selecting the grip finish or leather treatment."
    },
    leather: {
      eyebrow: "03 · Grip Finish",
      title: "Leather & Grip Finish",
      copy: "Choose whether the grip will be leather wrapped or left in its raw finish. Leather builds require leather color and stitching selections; non-leather builds use the applicable raw-grip template."
    },
    horn: {
      eyebrow: "04 · Horn",
      title: "Horn Logo",
      copy: "Choose the horn-button marking treatment. Keep the standard SPARC logo, delete the logo for a clean appearance, or choose Custom and upload your own artwork."
    },
    mounting: {
      eyebrow: "05 · Mounting",
      title: "Mounting & Fitment",
      copy: "The adapter and hub-sleeve selections determine how the steering wheel interfaces with your steering column. Confirm the steering-column family carefully; aftermarket or retrofit columns may require additional fitment verification."
    },
    accessories: {
      eyebrow: "06 · Accessories",
      title: "Optional Accessories",
      copy: "Add compatible installation and care accessories to your steering wheel package. Column spacers are available in multiple depths and finishes, while the shared Steering Wheel Care Kit can be added independently."
    },
    summary: {
      eyebrow: "Build Review",
      title: "Configuration Summary",
      copy: "Review the complete build before adding it to your cart. This summary shows the currently selected finish, grip, leather or raw-grip choices, horn treatment, mounting selections, and optional accessories."
    }
  };

  function currentSectionImage(name) {
    var section = accs[name] && accs[name].section;
    if (!section) return "";

    var selected =
      q(".sparc-option-card.is-selected img", section) ||
      q(".sparc-option-card img", section);

    return selected ? (selected.currentSrc || selected.src || "") : "";
  }

  function currentSectionSelection(name) {
    var s = getState();

    if (name === "finish") return friendly(s.finish);
    if (name === "grip") return friendly(s.grip);

    if (name === "leather") {
      var leatherParts = [];

      if (s.leatherWrap) leatherParts.push(friendly(s.leatherWrap));

      if (
        refs.leatherColor &&
        sourceVisible(refs.leatherColor) &&
        s.leatherColor
      ) {
        leatherParts.push(friendly(s.leatherColor));
      }

      if (
        refs.stitching &&
        sourceVisible(refs.stitching) &&
        s.stitching
      ) {
        leatherParts.push(friendly(s.stitching) + " Stitch");
      }

      if (
        refs.leatherTemplate &&
        sourceVisible(refs.leatherTemplate) &&
        s.leatherTemplate
      ) {
        leatherParts.push(friendly(s.leatherTemplate));
      }

      return leatherParts.join(" · ");
    }

    if (name === "horn") return friendly(s.hornLogo);

    if (name === "mounting") {
      return [
        s.adapter,
        refs.hubSleeve &&
        sourceVisible(refs.hubSleeve) &&
        s.hubSleeve
          ? "Sleeve " + s.hubSleeve
          : ""
      ]
        .filter(Boolean)
        .map(friendly)
        .join(" · ");
    }

    if (name === "accessories") {
      var parts = [];

      if (refs.columnSpacer && sourceVisible(refs.columnSpacer) && s.columnSpacer) {
        if (!valueEquals(s.columnSpacer, "None")) {
          var spacer = friendly(s.columnSpacer) + " Column Spacer";

          if (
            refs.columnSpacerFinish &&
            sourceVisible(refs.columnSpacerFinish) &&
            s.columnSpacerFinish
          ) {
            spacer += " · " + friendly(s.columnSpacerFinish);
          }

          parts.push(spacer);
        }
      }

      if (
        refs.careKit &&
        sourceVisible(refs.careKit) &&
        valueEquals(s.careKit,"Yes")
      ) {
        parts.push("Steering Wheel Care Kit");
      }

      return parts.length ? parts.join(" · ") : "None";
    }

    return "";
  }

  function ensureInfoModal() {
    var existing = document.getElementById("sparc-info-modal");
    if (existing) return existing;

    var modal = el("div","");
    modal.id = "sparc-info-modal";
    modal.setAttribute("aria-hidden","true");

    var backdrop = el("div","sparc-info-modal__backdrop","");
    modal.appendChild(backdrop);

    var dialog = el("div","sparc-info-modal__dialog","");
    dialog.setAttribute("role","dialog");
    dialog.setAttribute("aria-modal","true");

    var head = el("div","sparc-info-modal__head","");
    var titleWrap = el("div","","");

    titleWrap.appendChild(
      el("span","sparc-info-modal__eyebrow","")
    );

    titleWrap.appendChild(
      el("h2","sparc-info-modal__title","")
    );

    var close = el("button","sparc-info-modal__close","×");
    close.type = "button";
    close.setAttribute("aria-label","Close information popup");

    head.appendChild(titleWrap);
    head.appendChild(close);
    dialog.appendChild(head);

    var body = el("div","sparc-info-modal__body","");
    var image = document.createElement("img");
    image.className = "sparc-info-modal__image";

    body.appendChild(image);

    body.appendChild(
      el("div","sparc-info-modal__thumbs","")
    );

    body.appendChild(
      el("div","sparc-info-modal__selection","")
    );
    body.appendChild(
      el("div","sparc-info-modal__copy","")
    );

    dialog.appendChild(body);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden","true");
      document.body.classList.remove("sparc-modal-open");
    }

    close.addEventListener("click",closeModal);
    backdrop.addEventListener("click",closeModal);

    document.addEventListener("keydown",function(e){
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    return modal;
  }

  function openInfoModal(name) {
    var content = INFO_CONTENT[name];
    if (!content) return;

    var modal = ensureInfoModal();

    q(".sparc-info-modal__eyebrow",modal).textContent = content.eyebrow;
    q(".sparc-info-modal__title",modal).textContent = content.title;
    q(".sparc-info-modal__copy",modal).textContent = content.copy;

    var selection = q(".sparc-info-modal__selection",modal);
    var selectedText = currentSectionSelection(name);
    selection.textContent = selectedText
      ? "CURRENT SELECTION · " + selectedText
      : "NO SELECTION YET";

    var image = q(".sparc-info-modal__image",modal);
    var src = currentSectionImage(name);

    if (src) {
      image.src = src;
      image.alt = content.title;
      image.classList.add("has-image");
    } else {
      image.removeAttribute("src");
      image.classList.remove("has-image");
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden","false");
    document.body.classList.add("sparc-modal-open");
  }

  function currentMuscleProductTitle() {
    /*
      The Muscle product template already renders Shopify's current product
      title in the page H1. Read that instead of hardcoding a wheel name so
      one configurator asset works for Truss, Triple Crown, and every other
      Muscle Series product using the template.
    */
    var selectors = [
      '#ProductSection .product-single__title',
      '.product-single__title',
      '[itemprop="name"].product-single__title',
      'h1[itemprop="name"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var node = document.querySelector(selectors[i]);
      if (node) {
        var title = clean(node.textContent || '');
        if (title) return title;
      }
    }

    /* Last-resort fallback from document title; strip store suffix. */
    var docTitle = clean(document.title || '');
    if (docTitle) {
      var parts = docTitle.split(/\s+[–—|-]\s+/);
      if (parts[0]) return clean(parts[0]);
    }

    return 'Steering Wheel';
  }

  function buildPanel() {
    /* Preserve the exact V40 mounting behavior. Accessories must never
       expand the common ancestor and change where the configurator mounts. */
    var anchor=(sourceGroups.finish || [])[0];
    sourceHost=anchor && (anchor.closest(".hulkapps_option_set") || anchor.parentElement);
    if(!sourceHost || !sourceHost.parentNode) return false;

    panel=el("section",""); panel.id="sparc-muscle-configurator";

    var header=el("div","sparc-build-header"), row=el("div","sparc-build-header__row"), tw=el("div","");
    tw.appendChild(el("h2","sparc-build-title","Build Your " + currentMuscleProductTitle()));
    tw.appendChild(el("div","sparc-build-subtitle","Configure your steering wheel."));
    row.appendChild(tw);
    var metrics=el("div","sparc-build-metrics");
    var pm=el("div",""); pm.appendChild(el("span","sparc-metric-label","CONFIGURED PRICE"));
    var pv=el("strong","sparc-metric-value","—"); pv.id="sparc-config-price"; pm.appendChild(pv);
    var lm=el("div","sparc-lead-metric"); lm.appendChild(el("span","sparc-metric-label","EST. PRODUCTION"));
    var lv=el("strong","sparc-metric-value","—"); lv.id="sparc-config-lead"; lm.appendChild(lv);
    metrics.appendChild(pm);metrics.appendChild(lm);row.appendChild(metrics);header.appendChild(row);
    var qualifierBar=el("div","sparc-lead-qualifier-bar","");
    qualifierBar.id="sparc-config-lead-qualifier";
    qualifierBar.hidden=true;
    header.appendChild(qualifierBar);
    panel.appendChild(header);

    var tr=el("nav","sparc-config-tabs");
    tr.appendChild(makeTab("finish","FINISH"));tr.appendChild(makeTab("grip","GRIP"));
    tr.appendChild(makeTab("leather","LEATHER"));tr.appendChild(makeTab("horn","HORN"));
    tr.appendChild(makeTab("mounting","MOUNTING"));tr.appendChild(makeTab("accessories","ACCESSORIES"));
    tr.appendChild(makeTab("summary","SUMMARY"));
    panel.appendChild(tr);

    var list=el("div","sparc-accordion-list");

    accs.finish=accordion("finish","01","STEERING WHEEL FINISH");
    accs.finish.inner.appendChild(el("p","sparc-section-help","Choose the finish for the billet center and spoke assembly. Compare the appearance of each finish and any price difference before making your selection."));
    sharedMounts.finish=el("div");
    accs.finish.inner.appendChild(sharedMounts.finish);
    list.appendChild(accs.finish.section);

    accs.grip=accordion("grip","02","GRIP STYLE");
    accs.grip.inner.appendChild(el("p","sparc-section-help","Choose the grip profile and shape you prefer. Use the images to compare the four available grip geometries before selecting the grip finish or leather options."));
    sharedMounts.grip=el("div");
    accs.grip.inner.appendChild(sharedMounts.grip);
    list.appendChild(accs.grip.section);

    accs.leather=accordion("leather","03","LEATHER & GRIP FINISH");
    accs.leather.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose how the grip will be finished. Select Leather Wrap to choose leather color and stitching, or choose No Leather to keep the raw grip finish and select the applicable grip template."
      )
    );
    sharedMounts.leatherWrap=el("div");
    accs.leather.inner.appendChild(sharedMounts.leatherWrap);

    accs.leatherColorBlock=conditional();
    var lc=q(".sparc-conditional__inner",accs.leatherColorBlock);
    lc.appendChild(el("div","sparc-subhead","LEATHER COLOR"));
    accs.leatherColorChoices=el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-muscle-leather-color-mount"
    );
    lc.appendChild(accs.leatherColorChoices);
    accs.leather.inner.appendChild(accs.leatherColorBlock);

    accs.stitchBlock=conditional();
    var st=q(".sparc-conditional__inner",accs.stitchBlock);
    st.appendChild(el("div","sparc-subhead","STITCHING COLOR"));
    accs.stitchChoices=el(
      "div",
      "sparc-stitch-grid sparc-muscle-stitch-mount"
    );
    accs.stitchPrice=el("p","sparc-section-help sparc-stitch-price","");
    accs.stitchPrice.hidden=true;
    st.appendChild(accs.stitchPrice);
    st.appendChild(accs.stitchChoices);
    accs.leather.inner.appendChild(accs.stitchBlock);
    accs.stitchNotice=el("p","sparc-section-help", "Stitching options are not available for this combination yet. Please contact SPARC.");
    accs.stitchNotice.hidden=true;
    accs.leather.inner.appendChild(accs.stitchNotice);

    accs.templateBlock=conditional();
    var tp=q(".sparc-conditional__inner",accs.templateBlock);
    tp.appendChild(el("div","sparc-subhead","RAW GRIP TEMPLATE"));
    accs.templateChoices=el(
      "div",
      "sparc-choice-grid sparc-muscle-template-mount"
    );
    tp.appendChild(accs.templateChoices);
    accs.leather.inner.appendChild(accs.templateBlock);
    list.appendChild(accs.leather.section);

    accs.horn=accordion("horn","04","HORN LOGO");
    accs.horn.inner.appendChild(el("p","sparc-section-help","Choose the horn-button marking. Keep the standard SPARC logo, remove the logo for a clean horn button, or choose Custom to supply your own artwork."));
    sharedMounts.hornLogo=el("div");
    accs.horn.inner.appendChild(sharedMounts.hornLogo);
    accs.hornNotice=el("p","sparc-section-help", "Select a steering wheel finish to see its horn-logo options.");
    accs.horn.inner.appendChild(accs.hornNotice);

    accs.customLaserBlock = customUploadBlock();
    accs.horn.inner.appendChild(accs.customLaserBlock);

    list.appendChild(accs.horn.section);

    accs.mounting=accordion("mounting","05","MOUNTING");
    accs.mounting.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the steering-column adapter and whether to include a hub sleeve. These are fitment choices; use the visual cards and the information popup to compare the available mounting configurations."
      )
    );

    var adapterGroup = el("div","sparc-mounting-group");
    adapterGroup.appendChild(
      el("div","sparc-subhead","COLUMN ADAPTER")
    );
    sharedMounts.adapter=el("div");
    adapterGroup.appendChild(sharedMounts.adapter);
    accs.mounting.inner.appendChild(adapterGroup);

    accs.hubSleeveBlock=conditional();
    var sleeveInner=q(".sparc-conditional__inner",accs.hubSleeveBlock);
    var sleeveGroup = el("div","sparc-mounting-group");
    sleeveGroup.appendChild(
      el("div","sparc-subhead","HUB SLEEVE")
    );
    accs.hubSleeveChoices=el(
      "div",
      "sparc-card-grid sparc-card-grid--2 sparc-muscle-hub-sleeve-mount"
    );
    sleeveGroup.appendChild(accs.hubSleeveChoices);
    sleeveInner.appendChild(sleeveGroup);
    accs.mounting.inner.appendChild(accs.hubSleeveBlock);

    list.appendChild(accs.mounting.section);

    accs.accessories=accordion("accessories","06","ACCESSORIES");
    accs.accessories.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Add optional installation and care accessories to your steering wheel package. Accessories are not required to complete the steering wheel configuration."
      )
    );

    var spacerGroup = el("div","sparc-accessory-group");
    spacerGroup.appendChild(
      el("div","sparc-subhead","COLUMN SPACER")
    );
    spacerGroup.appendChild(
      el(
        "p",
        "sparc-accessory-help",
        "Choose None if no spacer is needed, or select the spacer depth that positions the steering wheel where you want it."
      )
    );
    accs.columnSpacerChoices=el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-column-spacer-choice-mount"
    );
    spacerGroup.appendChild(accs.columnSpacerChoices);
    accs.accessories.inner.appendChild(spacerGroup);

    accs.spacerFinishBlock=conditional();
    var sf=q(
      ".sparc-conditional__inner",
      accs.spacerFinishBlock
    );
    sf.appendChild(
      el("div","sparc-subhead","COLUMN SPACER FINISH")
    );
    sf.appendChild(
      el(
        "p",
        "sparc-accessory-help",
        "A spacer finish is required after selecting a 1\" or 1.5\" column spacer."
      )
    );
    accs.spacerFinishChoices=el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-spacer-finish-choice-mount"
    );
    sf.appendChild(accs.spacerFinishChoices);
    ensureAccessoryUI();
    accs.accessories.inner.appendChild(
      accs.spacerFinishBlock
    );

    var careGroup=el("div","sparc-accessory-group sparc-accessory-group--care");
    careGroup.appendChild(
      el("div","sparc-subhead","CARE & MAINTENANCE")
    );
    accs.careKitChoices=el(
      "div",
      "sparc-care-kit-choice-mount"
    );
    careGroup.appendChild(accs.careKitChoices);
    accs.accessories.inner.appendChild(careGroup);

    list.appendChild(accs.accessories.section);
    // Card clicks resolve live sources through the shared registry.

    accs.summary=accordion("summary","✓","CONFIGURATION SUMMARY");
    accs.summary.inner.appendChild(
      el(
        "p",
        "sparc-summary-intro",
        "Review every selected option, configured price, and fitment choice before adding your steering wheel to the cart."
      )
    );
    var sum=el("div","sparc-summary");

    [
      ["finish","Steering Wheel Finish"],
      ["grip","Grip Style"],
      ["leatherWrap","Leather Wrap"],
      ["leatherColor","Leather Color"],
      ["stitching","Stitching"],
      ["leatherTemplate","Raw Grip Template"],
      ["hornLogo","Horn Logo"],
      ["adapter","Adapter"],
      ["hubSleeve","Hub Sleeve"],
      ["columnSpacer","Column Spacer"],
      ["columnSpacerFinish","Spacer Finish"],
      ["careKit","Steering Wheel Care Kit"]
    ].forEach(function(pair){
      var row = el("div","sparc-summary-row");

      row.appendChild(
        el("div","sparc-summary__label",pair[1])
      );

      row.appendChild(
        el("span","sparc-summary__leader","")
      );

      var v=el("div","sparc-summary__value","—");
      v.dataset.summaryKey=pair[0];
      row.appendChild(v);

      sum.appendChild(row);
    });
    accs.summary.inner.appendChild(sum);list.appendChild(accs.summary.section);

    panel.appendChild(list);
    var panelSlot = document.getElementById("sparc-muscle-configurator-panel-slot");
    var dedicatedMount = document.getElementById("sparc-muscle-configurator-mount");

    if (panelSlot) {
      panelSlot.appendChild(panel);
    } else if (dedicatedMount) {
      dedicatedMount.insertBefore(panel, dedicatedMount.firstChild);
    } else {
      sourceHost.parentNode.insertBefore(panel, sourceHost);
    }

    Object.keys(refs).forEach(function(k){
      if (refs[k] && !panel.contains(refs[k])) {
        refs[k].classList.add("sparc-source-hidden");
      }
    });

    /* Hydrate any conditional Hulk selectors that already exist. Later
       conditional inserts are refreshed from sync(). */
    ensureMuscleConditionalUI();

    /* Now that every Accessories mount exists, hydrate the optional source
       selectors and hide their original Hulk controls as well. */
    ensureAccessoryUI();

    connectCustomLaserUpload();
    hideLegacyDecorations();
    openSection("finish");
    setTimeout(debugImageData, 250);
    return true;
  }

  function refreshVisualCardImages(root, section) {
    if (!root || !section) return;

    var latest=choices(root);

    qa(
      ".sparc-option-card[data-value]",
      section
    ).forEach(function(card) {
      if(card.dataset.sourceId !== root.id) return;
      var value=card.dataset.value;

      var choice=latest.find(function(c) {
        return String(c.value)===String(value);
      });

      if (!choice) return;

      var detail=matchingOptionDetail(
        root.id,
        value
      );

      var imageUrl=selectorImageForOption(
        root,
        value,
        choice.image
      );

      var imageWrap=q(
        ".sparc-option-card__image",
        card
      );

      if (!imageWrap) return;

      var existingImg=q(
        "img",
        imageWrap
      );

      var placeholder=q(
        ".sparc-option-card__placeholder",
        imageWrap
      );

      if (imageUrl) {
        if (!existingImg) {
          existingImg=
            document.createElement("img");

          imageWrap.innerHTML="";
          imageWrap.appendChild(existingImg);
        }

        existingImg.alt=
          detail && detail.imageAltText
            ? detail.imageAltText
            : friendly(value);

        if (existingImg.src!==imageUrl) {
          existingImg.src=imageUrl;
        }
      } else {
        if (existingImg) {
          imageWrap.innerHTML="";
          placeholder=null;
        }

        if (!placeholder) {
          placeholder=el(
            "div",
            "sparc-option-card__placeholder",
            "Add option image in Hulk Admin"
          );

          imageWrap.appendChild(
            placeholder
          );
        }
      }
    });
  }

  function replaceMountChildren(mount, content, sourceId) {
    if (!mount) return;

    var rendered = mount.dataset.sourceId || "";

    if (
      sourceId &&
      rendered === sourceId &&
      mount.children.length
    ) {
      return;
    }

    mount.innerHTML = "";
    mount.dataset.sourceId = sourceId || "";

    if (content) {
      moveChildren(content, mount);
    }
  }

  function renderSourceMount(mount, root, key) {
    if (!mount) return;
    var cs=choices(root);
    var signature=sourceToken(root)+JSON.stringify(cs.map(function(c){return [c.value,c.price,c.image,c.disabled];}));
    if(mount._sourceSignature===signature) return;
    mount._sourceSignature=signature;
    mount.replaceChildren();
    if(!root) return;
    var content;
    if(key==="stitching") content=stitchGrid(root);
    else if(key==="leatherWrap") content=choiceGrid(root,{
      "Yes":{title:"LEATHER WRAP",sub:"Leather color and stitching options appear below."},
      "None (raw finish)":{title:"NO LEATHER",sub:"Raw grip finish. Template option appears when applicable."}
    });
    else if(key==="leatherTemplate") content=choiceGrid(root,null);
    else if(key==="adapter") content=visualMountingGrid(root,"adapter");
    else if(key==="hubSleeve") content=visualMountingGrid(root,"sleeve");
    else content=cardGrid(root,key==="grip" || key==="hubSleeve" ? 2 : 3,key==="grip");
    // Preserve the existing role-specific image/layout hooks during redraws.
    if(!mount._layoutHooks) {
      mount._layoutHooks=Array.from(mount.classList).filter(function(name){
        return /-mount$/.test(name);
      });
    }
    mount.className=content.className;
    mount._layoutHooks.forEach(function(name){mount.classList.add(name);});
    moveChildren(content,mount);
    root.classList.add("sparc-source-hidden");
  }

  function extraSection(root) {
    return ["finish","grip","leather","horn","mounting","accessories"].find(function(k){
      return root.classList.contains("sparc-section-"+k);
    }) || "extras";
  }

  function ensureExtraUI() {
    var roots=sourceRoots.filter(function(r){
      var select=sourceSelect(r);
      return !sourceRole(r) && ((select && !select.multiple) || sourceInputs(r).length);
    });
    if(roots.length && !accs.extras) {
      accs.extras=accordion("extras","+","ADDITIONAL OPTIONS");
      accs.summary.section.before(accs.extras.section);
      tabs.summary.before(makeTab("extras","OPTIONS"));
    }
    extraFields.forEach(function(entry,root){
      if(roots.indexOf(root)<0) {entry.block.remove();entry.row.remove();extraFields.delete(root);}
    });
    roots.forEach(function(root){
      var entry=extraFields.get(root), section=extraSection(root);
      if(!entry) {
        var label=q(".hulkapps_option_name",root);
        var title=clean(label && (label.getAttribute("aria-label") || label.textContent)).replace(/\s*\*\s*$/," ").trim() || "Option";
        var block=el("div","sparc-extra-option");
        block.appendChild(el("div","sparc-subhead",title));
        var mount=el("div");block.appendChild(mount);
        accs[section].inner.appendChild(block);
        var row=el("div","sparc-summary-row");
        row.appendChild(el("div","sparc-summary__label",title));
        var value=el("div","sparc-summary__value");row.appendChild(value);
        q(".sparc-summary",accs.summary.section).appendChild(row);
        entry={block:block,mount:mount,row:row,value:value,section:section};
        extraFields.set(root,entry);
      }
      var visible=sourceVisible(root);
      entry.block.hidden=!visible; entry.row.hidden=!visible;
      renderSourceMount(entry.mount,visible ? root : null,"extra");
      syncChoiceClasses(root,entry.block);
      entry.value.textContent=current(root) ? friendly(current(root)) : "—";
    });
  }

  function ensureMuscleConditionalUI() {
    refreshRefs();
    sharedMounts.leatherColor=accs.leatherColorChoices;
    sharedMounts.stitching=accs.stitchChoices;
    sharedMounts.leatherTemplate=accs.templateChoices;
    sharedMounts.hubSleeve=accs.hubSleeveChoices;
    sharedMounts.columnSpacer=accs.columnSpacerChoices;
    sharedMounts.columnSpacerFinish=accs.spacerFinishChoices;
    sharedMounts.careKit=accs.careKitChoices;
    Object.keys(sharedMounts).forEach(function(k){renderSourceMount(sharedMounts[k],refs[k],k);});
    // All conditional alternatives are represented by the active group's cards.
    sourceRoots.forEach(function(root){if(sourceRole(root)) root.classList.add("sparc-source-hidden");});
    if(accs.hornNotice) {
      accs.hornNotice.hidden=!!refs.hornLogo;
      accs.hornNotice.textContent=current(refs.finish) ?
        "Horn-logo options are not available for this finish yet. Please contact SPARC." :
        "Select a steering wheel finish to see its horn-logo options.";
    }
    if(accs.summary) ensureExtraUI();
    ["finish","grip","leather","horn","mounting","accessories","extras"].forEach(function(section){
      if(!accs[section]) return;
      var visible=Object.keys(ROLE_SECTIONS).some(function(k){
        return ROLE_SECTIONS[k]===section && !!refs[k];
      });
      if(section==="horn" && sourceGroups.hornLogo.length) visible=true;
      extraFields.forEach(function(entry,root){if(entry.section===section && sourceVisible(root)) visible=true;});
      accs[section].section.hidden=!visible;
      if(tabs[section]) tabs[section].hidden=!visible;
    });
  }

  function syncChoiceClasses(root, section) {
    if (!root || !section) return;

    var values=sourceInputs(root).filter(function(i){return i.checked;}).map(function(i){return String(i.value);});
    if(sourceSelect(root)) values=[String(current(root))];

    qa("[data-source-id][data-value]", section).forEach(function(node) {
      if (node.dataset.sourceId !== root.id) return;

      node.classList.toggle(
        "is-selected",
        values.indexOf(String(node.dataset.value)) !== -1
      );
    });
  }

  function setConditional(block, show) {
    if (!block) return;
    block.classList.toggle("is-visible", !!show);
  }
  function moveChildren(from,to) {
    while (from && from.firstChild) {
      to.appendChild(from.firstChild);
    }
  }

  function hideLegacyAccessoryLabels() {
    if (!panel) return;

    var form =
      panel.closest("form") ||
      document.querySelector("form[action*='/cart/add']") ||
      document;

    [
      "steering wheel care kit",
      "column spacer finish",
      "muscle series column spacer finish"
    ].forEach(function(wanted){
      var matches = qa("*",form).filter(function(node){
        if (panel.contains(node)) return false;
        if (node.classList.contains("sparc-source-hidden")) return false;
        if (node.classList.contains("sparc-source-decoration-hidden")) return false;
        if (containsCoreRef(node)) return false;

        return clean(node.textContent).toLowerCase() === wanted;
      });

      matches.sort(function(a,b){
        if (a.children.length !== b.children.length) {
          return a.children.length - b.children.length;
        }

        var ar = a.getBoundingClientRect();
        var br = b.getBoundingClientRect();
        return (ar.width * ar.height) - (br.width * br.height);
      });

      if (matches.length) {
        matches[0].classList.add(
          "sparc-source-decoration-hidden"
        );
      }
    });
  }

  function safelyHideAccessorySource(root) {
    if (!root) return;
    if (!panel) return;
    if (root === sourceHost) return;
    if (root === panel || root.contains(panel)) return;
    if (containsCoreRef(root)) return;

    root.classList.add("sparc-source-hidden");
  }

  function accessoryKeyForSourceId(sourceId) {
    if (sourceId === IDS.columnSpacer) return "columnSpacer";
    if (sourceId === IDS.columnSpacerFinish) return "columnSpacerFinish";
    if (sourceId === IDS.careKit) return "careKit";
    return "";
  }

  function currentAccessoryRoot(key) {
    if (
      key === "careKit" ||
      key === "columnSpacerFinish"
    ) {
      refs[key] = resolveAccessoryRef(key);
      return refs[key] || null;
    }

    refreshRefs();
    return refs[key] || null;
  }

  function watchForSpacerFinish(attempt) {
    clearTimeout(spacerFinishWatchTimer);
    spacerFinishWatchTimer = null;

    refs.columnSpacerFinish =
      resolveAccessoryRef("columnSpacerFinish");

    if (refs.columnSpacerFinish) {
      safelyHideAccessorySource(refs.columnSpacerFinish);
      ensureAccessoryUI();
      delayedSync();
      return;
    }

    if (attempt >= 5) return;

    spacerFinishWatchTimer = setTimeout(function(){
      watchForSpacerFinish(attempt + 1);
    }, 80 + (attempt * 70));
  }

  function bindLiveAccessoryClicks() {
    if (!accs.accessories || !accs.accessories.section) return;
    if (accs.accessories.section._sparcLiveAccessoryBound) return;

    accs.accessories.section._sparcLiveAccessoryBound = true;

    accs.accessories.section.addEventListener(
      "click",
      function(e){
        /* Let the existing info-button popup handler run normally. */
        if (e.target.closest(".sparc-option-info")) return;

        var card = e.target.closest(
          ".sparc-option-card[data-source-id]"
        );

        if (!card || !accs.accessories.section.contains(card)) return;

        var sourceId = card.dataset.sourceId || "";
        var key =
          card.dataset.accessoryKey ||
          accessoryKeyForSourceId(sourceId);

        if (!key) return;

        var root = currentAccessoryRoot(key);
        if (!root) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        if (key === "careKit") {
          e.__sparcCareHandled = true;

          var nextValue =
            valueEquals(current(root),"Yes")
              ? "No"
              : "Yes";

          choose(root,nextValue);

          requestAnimationFrame(function(){
            logAccessoryDebug("care kit click");
            var liveCare = currentAccessoryRoot("careKit");
            if (liveCare) {
              syncChoiceClasses(
                liveCare,
                accs.accessories.section
              );
            }
          });

          return;
        }

        var value = card.dataset.value || "";
        if (!value) return;

        choose(root,value);
        logAccessoryDebug("accessory card click");

        if (key === "columnSpacer") {
          if (spacerIsSelected(value)) {
            /* Hulk inserts the conditional Finish field asynchronously.
               Watch only this one field for less than ~1 second. */
            watchForSpacerFinish(0);
          } else {
            clearTimeout(spacerFinishWatchTimer);
            spacerFinishWatchTimer = null;
          }
        }
      },
      true
    );
  }

  function ensureAccessoryUI() {
    // All fields now use the same live-source renderer.
  }

  function syncMirror(field,root) { if(field&&field._mirror) field._mirror.value=current(root); }

  function sync() {
    syncPending=false;
    if(!panel)return;

    refreshRefs();
    ensureMuscleConditionalUI();
    ensureAccessoryUI();
    syncLaserMarkingTicket();
    syncStitchingTicket();
    syncBuildTickets();
    orderTicketFields();

    var s=getState();

    var leatherColorVisible = !!(refs.leatherColor && sourceVisible(refs.leatherColor));
    var stitchingVisible = !!(refs.stitching && sourceVisible(refs.stitching));
    var templateVisible = !!(refs.leatherTemplate && sourceVisible(refs.leatherTemplate));
    if(accs.stitchPrice) {
      var stitchChoices=choices(refs.stitching);
      var commonStitchPrice=stitchChoices.length ? stitchChoices[0].price : "";
      if(!stitchChoices.every(function(c){return c.price===commonStitchPrice;})) commonStitchPrice="";
      var priceText=commonStitchPrice && commonStitchPrice!=="Included" ? "Leather wrap & stitching: "+commonStitchPrice : "";
      if(accs.stitchPrice.textContent!==priceText) accs.stitchPrice.textContent=priceText;
      accs.stitchPrice.hidden=!priceText;
    }
    if(accs.stitchNotice) accs.stitchNotice.hidden=!(
      sourceGroups.stitching.length && isYesValue(s.leatherWrap) && s.leatherColor && !refs.stitching
    );
    var hubSleeveVisible = !!(refs.hubSleeve && sourceVisible(refs.hubSleeve));
    var spacerFinishVisible = !!(refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish));

    syncChoiceClasses(refs.finish,accs.finish.section);
    syncChoiceClasses(refs.grip,accs.grip.section);
    syncChoiceClasses(refs.leatherWrap,accs.leather.section);
    syncChoiceClasses(refs.leatherColor,accs.leather.section);
    syncChoiceClasses(refs.stitching,accs.leather.section);
    syncChoiceClasses(refs.leatherTemplate,accs.leather.section);
    syncChoiceClasses(refs.hornLogo,accs.horn.section);
    syncChoiceClasses(refs.adapter,accs.mounting.section);
    syncChoiceClasses(refs.hubSleeve,accs.mounting.section);
    syncChoiceClasses(refs.columnSpacer,accs.accessories.section);
    syncChoiceClasses(refs.columnSpacerFinish,accs.accessories.section);
    syncChoiceClasses(refs.careKit,accs.accessories.section);

    refreshVisualCardImages(refs.finish, accs.finish.section);
    refreshVisualCardImages(refs.grip, accs.grip.section);
    if (refs.leatherColor) refreshVisualCardImages(refs.leatherColor, accs.leather.section);
    refreshVisualCardImages(refs.hornLogo, accs.horn.section);
    refreshVisualCardImages(refs.adapter, accs.mounting.section);
    if (refs.hubSleeve) refreshVisualCardImages(refs.hubSleeve, accs.mounting.section);
    if (refs.columnSpacer) refreshVisualCardImages(refs.columnSpacer, accs.accessories.section);
    if (refs.columnSpacerFinish) refreshVisualCardImages(refs.columnSpacerFinish, accs.accessories.section);
    if (refs.careKit) refreshVisualCardImages(refs.careKit, accs.accessories.section);

    /* Hulk conditional visibility is the source of truth. */
    setConditional(accs.leatherColorBlock, leatherColorVisible);
    setConditional(accs.stitchBlock, stitchingVisible);
    setConditional(accs.templateBlock, templateVisible);
    setConditional(accs.hubSleeveBlock, hubSleeveVisible);
    setConditional(accs.spacerFinishBlock, spacerFinishVisible);

    var customSource=findCustomLaserFileSource();
    var customSourceNode=customSource && (customSource.input || customSource.wrapper);
    var customUploadVisible=!!(customSourceNode && sourceVisible(customSourceNode));
    var customHornSelected=valueEquals(s.hornLogo,"Custom");

    if (accs.customLaserBlock) {
      accs.customLaserBlock.classList.toggle(
        "is-hidden",
        !customUploadVisible
      );

      accs.customLaserBlock.style.display = customUploadVisible
        ? "block"
        : "";
    }

    /* Selecting Custom is only used to trigger finite discovery retries.
       Hulk's real file field still decides whether the visual upload is shown. */
    if (customHornSelected || customUploadVisible) {
      connectCustomLaserUpload();
      setTimeout(connectCustomLaserUpload,120);
      setTimeout(connectCustomLaserUpload,400);
      setTimeout(connectCustomLaserUpload,900);
    }

    q("#sparc-config-price",panel).textContent=configuredPrice();
    q("#sparc-config-lead",panel).textContent=leadTime(s);

    var leadQualifierNode=q("#sparc-config-lead-qualifier",panel);

    if (leadQualifierNode) {
      var qualifier=leadQualifier(s);
      leadQualifierNode.textContent=qualifier;
      leadQualifierNode.hidden=!qualifier;
      leadQualifierNode.classList.toggle("is-visible",!!qualifier);
    }

    if (leadDebugEnabled()) setTimeout(renderLeadDebug,0);

    q(".sparc-accordion__summary",accs.finish.section).textContent=friendly(s.finish);
    q(".sparc-accordion__summary",accs.grip.section).textContent=friendly(s.grip);

    var leatherParts=[];
    if (s.leatherWrap) leatherParts.push(friendly(s.leatherWrap));

    if (leatherColorVisible) {
      leatherParts.push(
        s.leatherColor
          ? friendly(s.leatherColor)
          : "Leather color required"
      );
    }

    if (stitchingVisible) {
      leatherParts.push(
        s.stitching
          ? friendly(s.stitching) + " Stitch"
          : "Stitching required"
      );
    }

    if (templateVisible) {
      leatherParts.push(
        s.leatherTemplate
          ? friendly(s.leatherTemplate)
          : "Template required"
      );
    }

    q(".sparc-accordion__summary",accs.leather.section).textContent=
      leatherParts.length ? leatherParts.join(" · ") : "Not selected";

    q(".sparc-accordion__summary",accs.horn.section).textContent=friendly(s.hornLogo);

    var ms=s.adapter?friendly(s.adapter):"Not selected";
    if (hubSleeveVisible && s.hubSleeve) {
      ms += " · Sleeve " + friendly(s.hubSleeve);
    }
    q(".sparc-accordion__summary",accs.mounting.section).textContent=ms;

    var accessoryParts=[];

    if (refs.columnSpacer && sourceVisible(refs.columnSpacer) && s.columnSpacer && !valueEquals(s.columnSpacer,"None")) {
      var spacerSummary=friendly(s.columnSpacer)+" Spacer";

      if (spacerFinishVisible) {
        spacerSummary += s.columnSpacerFinish
          ? " · " + friendly(s.columnSpacerFinish)
          : " · Finish required";
      }

      accessoryParts.push(spacerSummary);
    }

    if (
      refs.careKit &&
      sourceVisible(refs.careKit) &&
      valueEquals(s.careKit,"Yes")
    ) {
      accessoryParts.push("Care Kit");
    }

    q(".sparc-accordion__summary",accs.accessories.section).textContent=
      accessoryParts.length ? accessoryParts.join(" · ") : "None selected";

    qa("[data-summary-key]",accs.summary.section).forEach(function(n){
      var key=n.dataset.summaryKey;
      var v=s[key];
      var summaryRow=n.closest(".sparc-summary-row");
      if(summaryRow) summaryRow.hidden=!refs[key];

      if(key==="leatherColor"&&!leatherColorVisible)v="";
      if(key==="stitching"&&!stitchingVisible)v="";
      if(key==="leatherTemplate"&&!templateVisible)v="";
      if(key==="hubSleeve"&&!hubSleeveVisible)v="";
      if(key==="columnSpacer"&&(!v||valueEquals(v,"None")))v="";
      if(key==="columnSpacerFinish"&&!spacerFinishVisible)v="";
      if(key==="careKit")v=(refs.careKit&&sourceVisible(refs.careKit)&&valueEquals(v,"Yes"))?"Included":"";

      n.textContent=v?friendly(v):"—";
    });

    if (sparcValidationAttempted) applyValidationState();

    scheduleResize();
  }

  function queueSync(){
    if(syncPending)return;
    syncPending=true;
    requestAnimationFrame(sync);
  }

  function delayedSync(){
    /* Update visible state immediately and perform one short settle pass
       after Hulk finishes conditional/pricing work. No perpetual polling. */
    queueSync();
    clearTimeout(syncTimer);
    syncTimer=setTimeout(function(){
      syncTimer=null;
      queueSync();

      if (panel) {
        var priceNode=q("#sparc-config-price",panel);
        if (priceNode) priceNode.textContent=configuredPrice();
      }
    },140);
  }

  function scheduleResize() {
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(function(){
      var stage=q(".sparc-muscle-product-stage");
      var col=q(".sparc-muscle-options-column");
      if(!stage||!col||window.innerWidth<=860)return;
      stage.style.minHeight=Math.max(800,col.scrollHeight+60)+"px";
    },450);
  }



  function activateTrueMuscleWidth() {
    if (!panel) return;

    document.body.classList.add("sparc-muscle-v13-active");

    var main = document.getElementById("MainContent");
    if (!main || !main.parentElement) return;

    /* In this older Supply layout, sidebar and MainContent are siblings in the
       same .grid. Hide every sibling except MainContent only after the Muscle
       Hulk configurator has successfully initialized. */
    Array.prototype.forEach.call(main.parentElement.children, function(child) {
      if (child !== main) {
        child.classList.add("sparc-muscle-v13-sidebar-hidden");
      }
    });
  }

  function hideSmallestExactText(root, regex, className) {
    if (!root || !panel) return;

    var panelTop = panel.getBoundingClientRect().top;
    var matches = qa("*", root).filter(function(node) {
      if (panel.contains(node)) return false;
      if (node.classList.contains("sparc-source-hidden")) return false;

      var text = clean(node.textContent);
      if (!regex.test(text)) return false;

      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return false;

      return true;
    });

    /* Prefer the smallest/most-specific matching element. */
    matches.sort(function(a, b) {
      var aText = clean(a.textContent).length;
      var bText = clean(b.textContent).length;
      if (aText !== bText) return aText - bText;
      return a.children.length - b.children.length;
    });

    if (matches.length) {
      matches[0].classList.add(className);
    }
  }

  function hideLegacyTopPriceAndLeadV13() {
    if (!panel) return;

    var meta =
      panel.closest(".sparc-muscle-product-meta") ||
      panel.closest(".product-single__meta") ||
      panel.parentElement;

    if (!meta) return;

    hideSmallestExactText(
      meta,
      /^\$[\d,]+(?:\.\d{2})?$/,
      "sparc-v13-old-price"
    );

    hideSmallestExactText(
      meta,
      /^Up to\s+\d+\s+week(?:s)?\s+lead\s+time$/i,
      "sparc-v13-old-lead"
    );
  }

  function moveQuantityBelowConfigurator() {
    if (!panel) return;

    var form =
      (document.getElementById("sparc-muscle-configurator-mount") &&
       document.getElementById("sparc-muscle-configurator-mount").closest("form")) ||
      panel.closest("form") ||
      q("form.product-form");

    if (!form) return;

    var realInput =
      q('input[name="quantity"]', form) ||
      q('#Quantity', form) ||
      q('input[name="quantity"]', document);

    if (!realInput) return;

    /* Hide every theme quantity presentation tied to the real field. */
    qa(".product-single__quantity", document).forEach(function(block) {
      if (block.contains(realInput) || q('input[name="quantity"]',block)) {
        block.classList.add("sparc-real-quantity-hidden");
      }
    });

    var host =
      document.getElementById("sparc-muscle-configurator-panel-slot") ||
      panel.parentElement;

    var mirror = q(".sparc-quantity-mirror", host);

    if (!mirror) {
      mirror = el("div","sparc-quantity-mirror");

      var label = el(
        "label",
        "sparc-quantity-mirror__label",
        "QUANTITY"
      );

      var input = document.createElement("input");
      input.type = "number";
      input.min = realInput.min || "1";
      input.step = realInput.step || "1";
      input.value = realInput.value || "1";
      input.className = "sparc-quantity-mirror__input";

      mirror.appendChild(label);
      mirror.appendChild(input);

      /* Always directly after panel, full host width. */
      host.insertBefore(mirror,panel.nextSibling);

      input.addEventListener("input",function() {
        realInput.value = input.value;
        realInput.dispatchEvent(new Event("input",{bubbles:true}));
        realInput.dispatchEvent(new Event("change",{bubbles:true}));
      });

      input.addEventListener("change",function() {
        realInput.value = input.value;
        realInput.dispatchEvent(new Event("change",{bubbles:true}));
      });

      realInput.addEventListener("change",function() {
        if (input.value !== realInput.value) {
          input.value = realInput.value;
        }
      });
    }

    var mirrorInput = q(".sparc-quantity-mirror__input",mirror);

    if (mirrorInput && mirrorInput.value !== realInput.value) {
      mirrorInput.value = realInput.value || "1";
    }

    /* Repair order on every call. */
    if (panel.nextSibling !== mirror) {
      host.insertBefore(mirror,panel.nextSibling);
    }
  }

  function hideOldProductPriceAndLeadTime() {
    if (!panel) return;

    var meta = panel.closest(".sparc-muscle-product-meta") || panel.parentElement;
    if (!meta) return;

    var panelTop = panel.getBoundingClientRect().top;

    /* Hide standalone price-only elements above the configurator.
       Do not touch anything inside the custom panel or Hulk's total source. */
    qa("*", meta).forEach(function(node) {
      if (panel.contains(node)) return;
      if (node.classList.contains("sparc-source-hidden")) return;

      var text = clean(node.textContent);
      if (!text) return;

      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return;

      if (
        node.children.length === 0 &&
        /^\$[\d,]+(?:\.\d{2})?$/.test(text)
      ) {
        node.classList.add("sparc-old-product-price-hidden");
      }

      if (
        node.children.length === 0 &&
        /^(?:up to\s+)?\d+\s*(?:-|–|to)?\s*\d*\s*week(?:s)?(?:\s+lead\s+time)?$/i.test(text)
      ) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });

    /* Common legacy lead-time wording in this product template. */
    qa("p,div,span", meta).forEach(function(node) {
      if (panel.contains(node)) return;
      if (node.children.length > 1) return;

      var text = clean(node.textContent);
      var rect = node.getBoundingClientRect();
      if (rect.top >= panelTop) return;

      if (/^Up to \d+\s*week(?:s)? lead time$/i.test(text)) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });
  }

  function applyV11Polish() {
    if(document.querySelector(".sparc-series-muscle,[id^=\"sparc-muscle-finish\"]")) activateTrueMuscleWidth();
    moveQuantityBelowConfigurator();
    hideOldProductPriceAndLeadTime();
    hideLegacyTopPriceAndLeadV13();
  }


  var sparcValidationAttempted = false;

  function hasUploadedCustomFile() {
    if (!accs.customLaserBlock) return false;

    /* If proxy has a file, require successful mirroring into Hulk's real field. */
    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    var source = findCustomLaserFileSource();
    var input =
      accs.customLaserBlock._sparcFileInput ||
      (source && source.input);

    return !!(
      input &&
      input.files &&
      input.files.length > 0
    );
  }

  function sectionValidity(s) {
    var leatherOK = !stitchTicketError && (!refs.leatherWrap || !!s.leatherWrap);
    // A wrapped build must not silently omit stitching when no conditional
    // group matches (or two groups match) after a grip/color change.
    if(sourceGroups.stitching.length && isYesValue(s.leatherWrap)) {
      leatherOK=leatherOK && !!refs.stitching && !!s.stitching;
    }

    if (refs.leatherColor && sourceVisible(refs.leatherColor)) {
      leatherOK = leatherOK && !!s.leatherColor;
    }

    if (refs.stitching && sourceVisible(refs.stitching)) {
      leatherOK = leatherOK && !!s.stitching;
    }

    if (refs.leatherTemplate && sourceVisible(refs.leatherTemplate)) {
      leatherOK = leatherOK && !!s.leatherTemplate;
    }

    var customSource=findCustomLaserFileSource();
    var customSourceNode=customSource && (customSource.input || customSource.wrapper);
    var customUploadVisible=!!(customSourceNode && sourceVisible(customSourceNode));

    var hornOK =
      !ticketBridgeError &&
      (!sourceGroups.hornLogo.length || !!s.hornLogo) &&
      (!customUploadVisible || hasUploadedCustomFile());

    var mountingOK = !refs.adapter || !!s.adapter;

    if (refs.hubSleeve && sourceVisible(refs.hubSleeve)) {
      mountingOK = mountingOK && !!s.hubSleeve;
    }

    var accessoriesOK = true;

    if (refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish)) {
      accessoriesOK = !!s.columnSpacerFinish;
    }

    var result = {
      finish: !refs.finish || !!s.finish,
      grip: !refs.grip || !!s.grip,
      leather: leatherOK,
      horn: hornOK,
      mounting: mountingOK,
      accessories: accessoriesOK
    };
    result.extras=true;
    extraFields.forEach(function(entry,root){
      var required=root.classList.contains("required") || !!q("[required],[aria-required='true']",root);
      if(required && sourceVisible(root) && !current(root)) result[entry.section]=false;
    });
    // Conflicting active alternatives must not silently pass validation.
    Object.keys(sourceGroups).forEach(function(k){
      if(sourceGroups[k].filter(sourceVisible).length>1) result[ROLE_SECTIONS[k]]=false;
    });
    Object.keys(buildTicketErrors).forEach(function(role){result[ROLE_SECTIONS[role]]=false;});
    return result;
  }

  function applyValidationState() {
    if (!panel) return true;

    var s = getState();
    var validity = sectionValidity(s);

    var firstInvalid = null;
    var anyInvalid = false;

    ["finish","grip","leather","horn","mounting","accessories","extras"].forEach(function(name) {
      var invalid = !validity[name];

      if (accs[name] && accs[name].section) {
        accs[name].section.classList.toggle("sparc-invalid", invalid);
      }

      if (invalid && !firstInvalid) firstInvalid = name;
      if (invalid) anyInvalid = true;
    });

    panel.classList.toggle("sparc-has-invalid", anyInvalid);

    return !anyInvalid;
  }

  function showValidationWarnings() {
    // Refresh synchronously before theme/Hulk click and submit handlers run.
    refreshRefs();
    syncLaserMarkingTicket();
    syncStitchingTicket();
    syncBuildTickets();
    orderTicketFields();
    var message=q(".sparc-validation-message",panel);
    if(message) message.textContent=ticketBridgeError ?
      "This horn cap configuration is temporarily unavailable. Please contact us for help with your selection." :
      stitchTicketError ? "This leather configuration is temporarily unavailable. Please contact us for help with your selection." :
      Object.keys(buildTicketErrors).length ? "This configuration is temporarily unavailable. Please contact us for help with your selection." :
      "Please complete the required configuration options highlighted below before adding this steering wheel to your cart.";
    sparcValidationAttempted = true;

    panel.classList.add("sparc-validation-attempted");

    var valid = applyValidationState();

    if (!valid) {
      var s = getState();
      var validity = sectionValidity(s);
      var firstInvalid = ["finish","grip","leather","horn","mounting","accessories","extras"].find(function(name) {
        return !validity[name];
      });

      if (firstInvalid) {
        openSection(firstInvalid);

        setTimeout(function() {
          if (accs[firstInvalid] && accs[firstInvalid].section) {
            accs[firstInvalid].section.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }, 80);
      }
    }

    return valid;
  }

  function isAddToCartControl(node) {
    if (!node) return false;

    var control = node.closest(
      'button,input[type="submit"],a'
    );

    if (!control) return false;

    var text = clean(
      (control.textContent || "") + " " +
      (control.value || "") + " " +
      (control.getAttribute("aria-label") || "")
    ).toLowerCase();

    return /add\s+to\s+cart/.test(text);
  }

  function installRequiredValidation() {
    if (!panel) return;

    /* Inline warning at top of accordion list; hidden until first failed
       Add-to-Cart attempt. */
    var list = q(".sparc-accordion-list", panel);

    if (list && !q(".sparc-validation-message", panel)) {
      var msg = el(
        "div",
        "sparc-validation-message",
        "Please complete the required configuration options highlighted below before adding this steering wheel to your cart."
      );

      list.insertBefore(msg, list.firstChild);
    }

    document.addEventListener(
      "click",
      function(e) {
        if (!isAddToCartControl(e.target)) return;

        /* Restrict to this product's option/form area. */
        var control = e.target.closest('button,input[type="submit"],a');
        var productArea =
          q(".sparc-muscle-options-column", document) ||
          q("#ProductSection", document);

        if (productArea && !productArea.contains(control)) return;

        if (!showValidationWarnings()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    var form = productOptionForm();

    if (form) {
      form.addEventListener(
        "submit",
        function(e) {
          if (!showValidationWarnings()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        },
        true
      );
    }
  }

  function accessoryDebugEnabled() {
    try {
      return new URLSearchParams(window.location.search)
        .get("sparc_accessory_debug") === "1";
    } catch(e) {
      return false;
    }
  }

  function logAccessoryDebug(label) {
    if (!accessoryDebugEnabled()) return;

    var spacer = refs.columnSpacer || null;
    var finish = resolveAccessoryRef("columnSpacerFinish");
    var care = resolveAccessoryRef("careKit");

    console.info("[SPARC V41.20 ACCESSORIES] " + label, {
      spacerValue: current(spacer),
      spacerRoot: spacer,
      finishValue: current(finish),
      finishRoot: finish,
      careValue: current(care),
      careRoot: care
    });
  }

  function ensureRuntimeBreadcrumbStyle() {
    if (document.getElementById("sparc-muscle-runtime-breadcrumb-style")) {
      return;
    }

    var style=document.createElement("style");
    style.id="sparc-muscle-runtime-breadcrumb-style";
    style.textContent =
      "#sparc-muscle-runtime-breadcrumb-wrap{" +
      "display:block!important;" +
      "box-sizing:border-box!important;" +
      "width:100%!important;" +
      "height:auto!important;" +
      "min-height:28px!important;" +
      "margin:0 0 18px!important;" +
      "padding:0!important;" +
      "overflow:visible!important;" +
      "}" +
      "#sparc-muscle-runtime-breadcrumb{" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "gap:7px!important;" +
      "height:auto!important;" +
      "min-height:22px!important;" +
      "margin:0!important;" +
      "padding:3px 0 4px!important;" +
      "line-height:17px!important;" +
      "overflow:visible!important;" +
      "font:inherit!important;" +
      "font-size:11px!important;" +
      "white-space:nowrap!important;" +
      "}" +
      "#sparc-muscle-runtime-breadcrumb a," +
      "#sparc-muscle-runtime-breadcrumb span{" +
      "display:inline-block!important;" +
      "position:static!important;" +
      "height:auto!important;" +
      "min-height:17px!important;" +
      "margin:0!important;" +
      "padding:1px 0!important;" +
      "line-height:17px!important;" +
      "overflow:visible!important;" +
      "vertical-align:middle!important;" +
      "text-decoration:none;" +
      "}" +
      "#sparc-muscle-runtime-breadcrumb .sparc-muscle-runtime-breadcrumb__sep{" +
      "opacity:.7;" +
      "}";

    document.head.appendChild(style);
  }

  function findLegacyMuscleBreadcrumbs(productTitle) {
    var titleNorm=clean(productTitle).toLowerCase();

    return qa("*",document).filter(function(node){
      if (!node || node===document.body || node===document.documentElement) {
        return false;
      }

      var rect=node.getBoundingClientRect();
      var text=clean(node.textContent).toLowerCase();

      if (
        rect.top < 50 ||
        rect.top > 280 ||
        rect.left < 40 ||
        rect.left > 650 ||
        rect.width <= 0 ||
        rect.width > 760 ||
        rect.height <= 0 ||
        rect.height > 90
      ) {
        return false;
      }

      var hasHome=text.indexOf("home") !== -1;
      var hasSeries=text.indexOf("muscle series") !== -1;
      var hasTitle=titleNorm && text.indexOf(titleNorm) !== -1;

      return (
        (hasHome && hasSeries) ||
        (hasSeries && hasTitle)
      );
    });
  }

  function normalizeRenderedBreadcrumbText(value) {
    return String(value || "")
      .replace(/[›>»\/|·•]/g," ")
      .replace(/[^a-zA-Z0-9]+/g," ")
      .replace(/\s+/g," ")
      .trim()
      .toLowerCase();
  }

  function hideRenderedLegacyBreadcrumb(runtimeWrap, productTitle) {
    if (!runtimeWrap) return;

    var runtimeRect = runtimeWrap.getBoundingClientRect();

    var target = normalizeRenderedBreadcrumbText(
      "Home Muscle Series " + productTitle
    );

    if (!target) return;

    var exact = [];
    var fallback = [];

    qa("*",document.body).forEach(function(node){
      if (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      ) {
        return;
      }

      var rect = node.getBoundingClientRect();

      /* Only inspect the visual breadcrumb zone ABOVE the clean runtime
         breadcrumb. This guarantees we cannot hide the replacement itself
         or anything down in the product area. */
      if (
        rect.width <= 0 ||
        rect.height <= 0 ||
        rect.left < 0 ||
        rect.left > 700 ||
        rect.top < 35 ||
        rect.top >= runtimeRect.top - 2 ||
        rect.width > 850 ||
        rect.height > 100
      ) {
        return;
      }

      /* innerText reflects the text the customer can actually see, unlike
         textContent which can include hidden/theme helper content. */
      var visible = "";
      try {
        visible = node.innerText || "";
      } catch(e) {
        visible = node.textContent || "";
      }

      var norm = normalizeRenderedBreadcrumbText(visible);
      if (!norm) return;

      var record = {
        node: node,
        rect: rect,
        norm: norm,
        area: rect.width * rect.height
      };

      if (norm === target) {
        exact.push(record);
        return;
      }

      /* Conservative fallback for themes that add a tiny hidden/pseudo word
         to the rendered line. */
      if (
        norm.indexOf("home") !== -1 &&
        norm.indexOf("muscle series") !== -1 &&
        norm.indexOf(
          normalizeRenderedBreadcrumbText(productTitle)
        ) !== -1 &&
        norm.length <= target.length + 24
      ) {
        fallback.push(record);
      }
    });

    var matches = exact.length ? exact : fallback;
    if (!matches.length) return;

    /* The smallest compact node containing the whole visible breadcrumb is
       the actual legacy line/list rather than a larger layout wrapper. */
    matches.sort(function(a,b){
      if (a.area !== b.area) return a.area - b.area;

      return b.rect.top - a.rect.top;
    });

    var legacy = matches[0].node;

    legacy.style.setProperty(
      "display",
      "none",
      "important"
    );

    legacy.setAttribute(
      "data-sparc-legacy-breadcrumb-hidden",
      "true"
    );
  }

  function hideLegacyBreadcrumbByLinks(runtimeWrap, productTitle) {
    if (!runtimeWrap) return;

    var runtimeRect = runtimeWrap.getBoundingClientRect();
    var titleNorm = clean(productTitle).toLowerCase();

    function visible(node) {
      if (!node) return false;
      var r = node.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function isRuntime(node) {
      return (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      );
    }

    /* 1) Remove every visible legacy line that contains a Home link plus
          a Muscle Series link. This is the clipped line visible in the
          screenshots. */
    qa("a",document).forEach(function(home){
      if (isRuntime(home)) return;
      if (clean(home.textContent).toLowerCase() !== "home") return;
      if (!visible(home)) return;

      var hr = home.getBoundingClientRect();

      /* Breadcrumbs are in the upper-left and above/near our replacement. */
      if (
        hr.left > 700 ||
        hr.top < 30 ||
        hr.top > runtimeRect.bottom + 25
      ) {
        return;
      }

      var p = home.parentElement;
      var line = null;

      for (var i=0; i<8 && p && p!==document.body; i++,p=p.parentElement) {
        if (isRuntime(p)) break;

        var links = qa("a",p);

        var hasHome = links.some(function(a){
          return clean(a.textContent).toLowerCase() === "home";
        });

        var hasSeries = links.some(function(a){
          return clean(a.textContent)
            .toLowerCase()
            .indexOf("muscle series") !== -1;
        });

        if (hasHome && hasSeries) {
          line = p;
          break;
        }
      }

      if (line && !isRuntime(line)) {
        line.style.setProperty(
          "display",
          "none",
          "important"
        );
        line.setAttribute(
          "data-sparc-legacy-breadcrumb-hidden",
          "home-series"
        );
      } else {
        /* Fail-safe: at minimum the old Home anchor itself cannot remain
           visible if Supply's markup prevents identifying its line root. */
        home.style.setProperty(
          "display",
          "none",
          "important"
        );
      }
    });

    /* 2) Remove a separate legacy Muscle Series > Product fragment if this
          Supply template renders one independently. Only linked Series text
          is considered, so the MUSCLE SERIES product eyebrow is untouched. */
    qa("a",document).forEach(function(series){
      if (isRuntime(series)) return;

      var st = clean(series.textContent).toLowerCase();

      if (st.indexOf("muscle series") === -1) return;
      if (!visible(series)) return;

      var sr = series.getBoundingClientRect();

      if (
        sr.left > 700 ||
        sr.top < 30 ||
        sr.top > runtimeRect.bottom + 35
      ) {
        return;
      }

      var p = series.parentElement;
      var fragment = null;

      for (var i=0; i<6 && p && p!==document.body; i++,p=p.parentElement) {
        if (isRuntime(p)) break;

        var text = clean(p.textContent).toLowerCase();
        var rect = p.getBoundingClientRect();

        var hasProduct =
          titleNorm &&
          text.indexOf(titleNorm) !== -1;

        var hasHome =
          text.indexOf("home") !== -1;

        if (
          hasProduct &&
          !hasHome &&
          rect.width > 0 &&
          rect.width < 700 &&
          rect.height > 0 &&
          rect.height < 80
        ) {
          fragment = p;
          break;
        }
      }

      if (fragment && !isRuntime(fragment)) {
        fragment.style.setProperty(
          "display",
          "none",
          "important"
        );
        fragment.setAttribute(
          "data-sparc-legacy-breadcrumb-hidden",
          "series-product"
        );
      }
    });
  }

  function replaceMuscleBreadcrumb() {
    if(!document.querySelector(".sparc-series-muscle,[id^=\"sparc-muscle-finish\"]")) return;
    ensureRuntimeBreadcrumbStyle();

    if (document.getElementById("sparc-muscle-runtime-breadcrumb-wrap")) {
      return;
    }

    var productTitle =
      currentMuscleProductTitle &&
      typeof currentMuscleProductTitle === "function"
        ? currentMuscleProductTitle()
        : "";

    if (!productTitle) {
      var title =
        q(".product-single__title") ||
        q("#ProductSection .product-single__title");
      productTitle=title ? clean(title.textContent) : "";
    }

    var homeLinks = qa("a",document).filter(function(a){
      return clean(a.textContent).toLowerCase() === "home";
    });

    var homeLink = null;
    var seriesLink = null;
    var originalBreadcrumb = null;

    homeLinks.some(function(home){
      /* Never use our own runtime breadcrumb as the source. */
      if (home.closest("#sparc-muscle-runtime-breadcrumb-wrap")) {
        return false;
      }

      var p = home.parentElement;

      for (var i=0; i<6 && p && p!==document.body; i++,p=p.parentElement) {
        var text = clean(p.textContent);
        var rect = p.getBoundingClientRect();

        var hasHome =
          text.toLowerCase().indexOf("home") === 0;

        var hasSeries =
          text.toLowerCase().indexOf("muscle series") !== -1;

        var compact =
          rect.top >= 40 &&
          rect.top < 260 &&
          rect.left < 700 &&
          rect.width > 0 &&
          rect.width < 800 &&
          rect.height > 0 &&
          rect.height < 90 &&
          text.length < 200;

        if (hasHome && hasSeries && compact) {
          homeLink = home;
          originalBreadcrumb = p;

          seriesLink = qa("a",p).find(function(a){
            return clean(a.textContent)
              .toLowerCase()
              .indexOf("muscle series") !== -1;
          }) || null;

          return true;
        }
      }

      return false;
    });

    var productSection =
      document.getElementById("ProductSection") ||
      q(".product-single") ||
      q("main");

    if (!productSection) return;

    var insertionTarget=productSection;

    var parent=productSection.parentElement;
    while (
      parent &&
      parent!==document.body &&
      parent.children.length===1 &&
      parent.getBoundingClientRect().width < 1200
    ) {
      insertionTarget=parent;
      parent=parent.parentElement;
    }

    var wrap=el(
      "div",
      "sparc-muscle-runtime-breadcrumb-wrap"
    );
    wrap.id="sparc-muscle-runtime-breadcrumb-wrap";

    var crumb=el(
      "nav",
      "sparc-muscle-runtime-breadcrumb"
    );
    crumb.id="sparc-muscle-runtime-breadcrumb";
    crumb.setAttribute(
      "aria-label",
      "Breadcrumb"
    );

    function addLink(source,fallbackText,fallbackHref) {
      var href =
        source && source.getAttribute("href")
          ? source.getAttribute("href")
          : fallbackHref;

      if (href) {
        var a=document.createElement("a");
        a.href=href;
        a.textContent=
          source && clean(source.textContent)
            ? clean(source.textContent)
            : fallbackText;
        crumb.appendChild(a);
      } else {
        crumb.appendChild(
          el("span","",fallbackText)
        );
      }
    }

    function sep() {
      crumb.appendChild(
        el(
          "span",
          "sparc-muscle-runtime-breadcrumb__sep",
          "›"
        )
      );
    }

    addLink(homeLink,"Home","/");
    sep();
    addLink(
      seriesLink,
      "Muscle Series",
      "/collections/muscle-series"
    );

    if (productTitle) {
      sep();

      var current=el(
        "span",
        "sparc-muscle-runtime-breadcrumb__current",
        productTitle
      );

      current.setAttribute(
        "aria-current",
        "page"
      );

      crumb.appendChild(current);
    }

    wrap.appendChild(crumb);

    insertionTarget.parentNode.insertBefore(
      wrap,
      insertionTarget
    );

    /* THE IMPORTANT V41.17 FIX:
       hide the exact compact legacy breadcrumb node that supplied the
       original Home link. This avoids depending on broad text matching. */
    if (
      originalBreadcrumb &&
      !originalBreadcrumb.contains(wrap)
    ) {
      originalBreadcrumb.style.setProperty(
        "display",
        "none",
        "important"
      );
    }

    /* Also hide any remaining compact legacy breadcrumb fragments nearby,
       but never touch the new runtime breadcrumb. */
    function cleanupLegacyFragments() {
      var titleNorm=
        clean(productTitle).toLowerCase();

      qa("*",document).forEach(function(node){
        if (
          node===wrap ||
          node===crumb ||
          wrap.contains(node) ||
          node.contains(wrap)
        ) {
          return;
        }

        var rect=node.getBoundingClientRect();

        if (
          rect.top < 40 ||
          rect.top > 260 ||
          rect.left < 20 ||
          rect.left > 700 ||
          rect.width <= 0 ||
          rect.width > 800 ||
          rect.height <= 0 ||
          rect.height > 90
        ) {
          return;
        }

        var text=
          clean(node.textContent).toLowerCase();

        var hasHome=
          text.indexOf("home") !== -1;

        var hasSeries=
          text.indexOf("muscle series") !== -1;

        var hasTitle=
          titleNorm &&
          text.indexOf(titleNorm) !== -1;

        if (
          (hasHome && hasSeries) ||
          (hasSeries && hasTitle)
        ) {
          /* Hide only compact text-level containers. */
          if (qa("img",node).length) return;
          if (qa("#ProductSection",node).length) return;

          node.style.setProperty(
            "display",
            "none",
            "important"
          );
        }
      });
    }

    cleanupLegacyFragments();

    hideRenderedLegacyBreadcrumb(
      wrap,
      productTitle
    );

    hideLegacyBreadcrumbByLinks(
      wrap,
      productTitle
    );

    [80,220,500,1000].forEach(function(delay){
      setTimeout(function(){
        cleanupLegacyFragments();

        hideRenderedLegacyBreadcrumb(
          wrap,
          productTitle
        );

        hideLegacyBreadcrumbByLinks(
          wrap,
          productTitle
        );
      },delay);
    });
  }


  function start() {
    if(document.getElementById("sparc-muscle-configurator"))return;
    var missing=allRefsPresent();
    if(missing.length){setTimeout(start,500);return;}

    if(!buildPanel())return;

    refreshRefs();
    ensureAccessoryUI();

    if (window.console && console.info) {
      var accessoryMissing = [
        ["columnSpacer",IDS.columnSpacer],
        ["columnSpacerFinish",IDS.columnSpacerFinish],
        ["careKit",IDS.careKit]
      ].filter(function(pair){
        if (pair[0] === "columnSpacerFinish") return false;
        return !refs[pair[0]];
      }).map(function(pair){ return pair[1]; });

      if (accessoryMissing.length) {
        console.info(
          "[SPARC Shared V42.5] Configurator started. Accessory selectors not currently found:",
          accessoryMissing
        );
      }
    }

    /* One settle pass is enough; dynamic Hulk inserts are caught by the
       child-list observer below. */
    setTimeout(delayedSync,120);

    applyV11Polish();

    replaceMuscleBreadcrumb();
    setTimeout(replaceMuscleBreadcrumb,120);
    installRequiredValidation();

    var observer=new MutationObserver(function(records) {
      var relevant=records.some(function(record){
        if(panel && panel.contains(record.target)) return false;
        if(record.type==="attributes" && record.attributeName==="class") {
          function externalClasses(value) {return String(value||"").split(/\s+/).filter(function(c){return c && !/^sparc-/.test(c);}).sort().join(" ");}
          if(externalClasses(record.oldValue)===externalClasses(record.target.className)) return false;
        }
        return true;
      });
      if(relevant) delayedSync();
    });
    observer.observe(sourceHost.parentElement || sourceHost,{
      subtree:true,childList:true,attributes:true,attributeOldValue:true,
      attributeFilter:["class","style","hidden","disabled","aria-hidden","value","data-price","data-variant-id"]
    });
    var eventHost=sourceHost.parentElement || sourceHost;
    eventHost.addEventListener("change",delayedSync,true);
    eventHost.addEventListener("input",delayedSync,true);
    window.addEventListener("resize",scheduleResize);

    var detailData=optionDetailData();

    if (
      detailData &&
      Array.isArray(detailData.entries)
    ) {
      console.info(
        "[SPARC Shared V42.5] Shopify option-detail entries loaded:",
        detailData.entries
      );
    }

    var leadData = leadTimeData();

    if (leadData && Array.isArray(leadData.rules)) {
      console.info(
        "[SPARC Shared V42.5] Lead-time bridge loaded:",
        {
          bridgeVersion: leadData.bridgeVersion,
          ruleCount: leadData.ruleCount,
          productHandle: leadData.productHandle,
          seriesScope: leadData.seriesScope,
          rules: leadData.rules
        }
      );

      leadData.rules.forEach(function(rule) {
        if (!validLeadRule(rule)) {
          console.warn(
            "[SPARC Shared V42.5] Invalid lead-time rule ignored:",
            rule
          );
        }
      });

      var baseRule = baseLeadRule();

      if (!baseRule) {
        console.warn(
          "[SPARC Shared V42.5] No valid Muscle Series Base lead-time rule was found."
        );
      }
    }

    delayedSync();scheduleResize();
    setTimeout(applyV11Polish, 150);
    setTimeout(applyV11Polish, 600);
    console.info("[SPARC Shared V42.5] Structural quantity placement + Hulk swatch media extraction active.");
    console.info("[SPARC Shared V42.5] V40 page polish reached successfully; Accessories extension active.");
    console.info("[SPARC Shared V42.5] Finish media:", choices(refs.finish).map(function(c){ return {value:c.value,image:c.image}; }));
    console.info("[SPARC Shared V42.5] Grip media:", choices(refs.grip).map(function(c){ return {value:c.value,image:c.image}; }));
    console.info("[SPARC MUSCLE] Hulk image swatches + condition source-of-truth revision active.");
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
  else start();
})();

/* SPARC cart summary V42.5 — presentation only; keep all Hulk properties. */
(function(){
  "use strict";
  if(window.__SPARC_CART_SUMMARY_V425__ || !/(?:^|\/)cart\/?$/.test(window.location.pathname)) return;
  window.__SPARC_CART_SUMMARY_V425__=true;
  var ROW="form.cart tr.cart__row", RAW=".cart-property", SUMMARY=".sparc-cart-build";
  var timer=null, signatures=new WeakMap();
  var fields=[
    {label:"Center Finish",names:["Steering Wheel Finish","Center Finish"]},
    {label:"Grip Style",names:["Grip Style","Grip Profile"]},
    {label:"Leather Wrap",names:["Leather Wrap?"]},
    {label:"Leather Color",names:["Leather Color"]},
    {label:"Stitching",names:["Stitching"],pattern:/^Stitching(?: Color)?\s*[-–—:]/i},
    {label:"Leather Template",names:["Leather Template?"]},
    {label:"Horn Logo",names:["Laser Marking?","Horn Logo?","Horn Logo"],pattern:/^Horn Cap\s*[-–—:]/i},
    {label:"Adapter",names:["Adapter","Mounting Adapter"]},
    {label:"Hub Sleeve",names:["Include Hub Sleeve?","Hub Sleeve"]}
  ];
  function list(selector,scope){return Array.prototype.slice.call((scope||document).querySelectorAll(selector));}
  function tidy(value){return String(value||"").replace(/\s+/g," ").trim();}
  function cleanValue(value){
    // Do not repeat Hulk's bracketed charges in generated text: the existing
    // cart price script sums those charges from the original row.textContent.
    return tidy(String(value||"")
      .replace(/\s*\[\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\]\s*/g," ")
      .replace(/\s*\|\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\|\s*/g," ")
      .replace(/\s*\(\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\)\s*/g," "));
  }
  function readProperty(node){
    var nameNode=node.querySelector(".property_name");
    if(!nameNode) return null;
    var key=tidy(nameNode.textContent).replace(/:\s*$/,"");
    var valueNode=node.querySelector(".property_value"), value;
    if(valueNode) value=valueNode.textContent;
    else {
      var copy=node.cloneNode(true), copiedName=copy.querySelector(".property_name");
      if(copiedName) copiedName.remove();
      value=copy.textContent;
    }
    var links=list("a[href]",valueNode||node).filter(function(a){return !nameNode.contains(a);}).map(function(a){
      return {text:tidy(a.textContent)||"View file",href:a.getAttribute("href")};
    }).filter(function(a){return /^(?:https?:\/\/|\/)/i.test(a.href);});
    return {node:node,key:key,value:cleanValue(value),links:links};
  }
  function matches(record,field){return field.names.indexOf(record.key)!==-1 || !!(field.pattern && field.pattern.test(record.key));}
  function buildEntries(records){
    if(!records.some(function(r){return matches(r,fields[0]);}) ||
       !records.some(function(r){return matches(r,fields[1]) || matches(r,fields[2]) || matches(r,fields[6]);})) return null;
    var used=new Set(), entries=[], conflict=false;
    fields.forEach(function(field){
      var candidates=records.filter(function(r){return r.value && matches(r,field);});
      if(!candidates.length) return;
      // Never conceal a disagreement between ticket data and an inventory field.
      if(candidates.some(function(r){return r.value!==candidates[0].value;})) {conflict=true;return;}
      var selected=candidates.slice().sort(function(a,b){
        var ai=field.names.indexOf(a.key),bi=field.names.indexOf(b.key);
        return (ai<0?100:ai)-(bi<0?100:bi);
      })[0];
      candidates.forEach(function(r){used.add(r);});
      var display=selected.value;
      if(field.label==="Leather Wrap" && display==="None (raw finish)") display="No";
      if(field.label==="Horn Logo" && display==="Sparc Logo Delete") display="Logo Delete";
      if(field.label==="Horn Logo" && display==="Sparc Logo") display="SPARC Logo";
      entries.push({label:field.label,value:display,links:selected.links});
    });
    if(conflict) return null;
    // Accessories, uploads, and newly added options remain visible automatically.
    records.forEach(function(r){
      if(!used.has(r) && r.key && r.key.charAt(0)!=="_" && (r.value || r.links.length))
        entries.push({label:r.key,value:r.value,links:r.links});
    });
    return entries;
  }
  function element(tag,cls,text){var n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;}
  function restore(row){
    list(RAW,row).forEach(function(n){n.classList.remove("sparc-cart-property-source");});
    list(SUMMARY,row).forEach(function(n){n.remove();});
    row.classList.remove("sparc-cart-build-row");signatures.delete(row);
  }
  function renderRow(row){
    var meta=row.querySelector(".cart__table-cell--meta");
    if(!meta) return;
    var records=list(RAW,meta).map(readProperty).filter(Boolean), entries=buildEntries(records);
    if(!entries || !entries.length){if(row.classList.contains("sparc-cart-build-row"))restore(row);return;}
    var signature=JSON.stringify(entries), summary=meta.querySelector(SUMMARY);
    if(!summary || signatures.get(row)!==signature){
      var next=element("section","sparc-cart-build");next.setAttribute("aria-label","Selected configuration");
      next.appendChild(element("p","sparc-cart-build__heading","YOUR CONFIGURATION"));
      var dl=element("dl","sparc-cart-build__list");
      entries.forEach(function(entry){
        var pair=element("div","sparc-cart-build__option");
        pair.appendChild(element("dt","",entry.label));
        var dd=element("dd","",entry.value);
        entry.links.forEach(function(link){
          var a=element("a","sparc-cart-build__file",link.text);a.href=link.href;
          a.target="_blank";a.rel="noopener noreferrer";dd.appendChild(a);
        });
        pair.appendChild(dd);dl.appendChild(pair);
      });
      next.appendChild(dl);
      if(summary) summary.replaceWith(next);else meta.insertBefore(next,records[0].node);
      signatures.set(row,signature);
    }
    // Hide source text visually only. Do not remove, edit, disable, or rename it:
    // Hulk and the configured-price script still need the original data/text.
    records.forEach(function(r){r.node.classList.add("sparc-cart-property-source");});
    row.classList.add("sparc-cart-build-row");
  }
  function update(){timer=null;list(ROW).forEach(renderRow);}
  function schedule(){if(timer===null)timer=window.setTimeout(update,60);}
  function relevant(node){
    var el=node.nodeType===1?node:node.parentElement;
    return !!(el && !el.closest(SUMMARY) && (el.matches(RAW) || el.closest(RAW) || el.querySelector(RAW)));
  }
  function start(){
    if(!document.getElementById("sparc-cart-summary-style")){
      var style=element("style");style.id="sparc-cart-summary-style";
      style.textContent=[
        "form.cart .cart-property.sparc-cart-property-source{display:none!important}",
        "form.cart .sparc-cart-build{margin:16px 0 18px;padding:16px 18px;border:1px solid #e6e2db;border-radius:10px;background:#faf9f6;color:#292929;text-align:left;max-width:540px}",
        "form.cart .sparc-cart-build__heading{margin:0 0 10px;font-size:10px;line-height:1.4;letter-spacing:.14em;font-weight:700;color:#806c4d}",
        "form.cart .sparc-cart-build__list{margin:0;padding:0}",
        "form.cart .sparc-cart-build__option{display:grid;grid-template-columns:112px minmax(0,1fr);gap:6px 14px;margin:0;padding:5px 0;font-size:13px;line-height:1.5}",
        "form.cart .sparc-cart-build__option dt{margin:0;padding:0;font-weight:400;color:#6a655e;overflow-wrap:anywhere}",
        "form.cart .sparc-cart-build__option dd{margin:0;padding:0;font-weight:600;color:#292929;overflow-wrap:anywhere}",
        "form.cart .sparc-cart-build__file{display:block;margin-top:3px;text-decoration:underline;text-underline-offset:3px}",
        "form.cart .sparc-cart-build-row>td{vertical-align:top;padding-top:24px;padding-bottom:24px}",
        "form.cart .sparc-cart-build-row .cart__table-cell--meta>p:first-child{margin-bottom:0;font-size:19px;font-weight:600}",
        "@media(max-width:749px){form.cart .sparc-cart-build{max-width:none;margin:14px 0;padding:14px}form.cart .sparc-cart-build__option{grid-template-columns:100px minmax(0,1fr);gap:6px 10px;font-size:13px}form.cart .sparc-cart-build-row>td{padding-top:12px;padding-bottom:12px}}"
      ].join("\n");document.head.appendChild(style);
    }
    update();
    var observer=new MutationObserver(function(changes){
      if(changes.some(function(change){
        if(change.type==="characterData" || change.type==="attributes")return relevant(change.target);
        if(change.target.nodeType===1 && change.target.closest(RAW))return true;
        return Array.prototype.some.call(change.addedNodes,relevant) || Array.prototype.some.call(change.removedNodes,relevant);
      }))schedule();
    });
    observer.observe(document.getElementById("MainContent") || document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:["href"]});
    document.addEventListener("shopify:section:load",schedule);
    window.addEventListener("pageshow",schedule);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});else start();
})();
